/* eslint-disable no-console */
/* eslint-disable require-jsdoc  */
/* eslint-disable valid-jsdoc */
'use strict';

var base = require('lyonscg/product/base');
var pdpInStore = require('./pdpInstoreInventory');
var utils = require('../utils');

var cookie = require('../util/cookie');
var atcWarantyModal = require('./addToCartModalWarranty');

var isBuyBoxOnPDPEnabled = $('#isBuyBoxOnPDPEnabled').val();
var isProcessRunning = false;
var isCheckAvailability = false;
var isDigitalProduct = false;
// check fulfillment option eligibility
var homeDeliveryEligible = false;
var sameDayDeliveryEligible = false;
var instoreDeliveryEligible = false;

// check fulfillment option availability
var homeDeliveryAvailable = false;
var sameDayDeliveryAvailable = false;
var instoreDeliveryAvailable = false;

var isProductInStock = true;
var isStoreClosedForSameDayDeliver = false;
var verifyAddress = false;

var buttonLabels = {};
const productVariationNotifyMeState = {
    set submitted(variation) {
        this.completed.push(variation);
    },
    set notifyMeForm(form) {
        this.form.push(form);
    },
    set empty(status) {
        if (status && status === true) {
            this.form = [];
            this.completed = [];
        }
    },
    completed: [],
    form: []
};

function getSelectedCarrier() {
    return $('.attribute.carrier')
        .find('.selected, [selected]')
        .attr('data-attr-value');
}
function getSelectedColor() {
    return $('.attribute.color-attribute')
        .find('.selected, [selected]')
        .attr('data-attr-value');
}
function getSelectedCondition() {
    return $('.attribute.condition-attribute')
        .find('.selected, [selected]')
        .attr('data-attr-value');
}
function getSelectedMemorySize() {
    return $('.attribute.memorySize')
        .find('.selected, [selected]')
        .attr('data-attr-value');
}
function getSelectedEdition() {
    return $('.attribute.edition')
        .find('.selected, [selected]')
        .attr('data-attr-value');
}
function getSelectedPlatform() {
    return $('.attribute.platform')
        .find('.selected, [selected]')
        .attr('data-attr-value');
}
function getSelectedSize() {
    return $('.attribute.size-attribute')
        .find('.selected, :selected')
        .attr('data-attr-value');
}

var getSelectionFunction = {
    carrier: getSelectedCarrier,
    color: getSelectedColor,
    condition: getSelectedCondition,
    memorySize: getSelectedMemorySize,
    edition: getSelectedEdition,
    size: getSelectedSize,
    platform: getSelectedPlatform
};

function getAttributesOnThePage() {
    let results = [];
    $.each($('.attribute').find('label'), function (index, el) {
        var classes = [...el.classList];
        results.push(
            classes.filter(
                (item) =>
                    [
                        'comp-label',
                        'form-control-label',
                        'edition-swatchable-label'
                    ].indexOf(item) < 0
            )
        );
    });

    return results.flat();
}

/**
 * Gets all DOM nodes in the page for a given attribute
 * eg. color
 */
function getAllDomNodesForAttribute(attr) {
    return $(`.product-variation-attributes .${attr} [data-attr-value]`);
}

/**
 * Checks if the attribute clicked on is sibling or not
 */
function isSiblingAttribute(domNode) {
    var $attribute = $(domNode).closest('.attribute');
    if ($attribute.length === 0) return false;

    return $attribute.hasClass('sibling-attribute');
}

function setBuyable(domNode, value) {
    if (value) {
        domNode.removeClass('not-buyable').addClass('buyable');
    } else {
        domNode.removeClass('buyable').addClass('not-buyable');
    }
}

/**
 * Sets url attribute on the DOM node
 */
function setUrl(refDomNode, url) {
    var actualDomNode = refDomNode;
    var urlAttribute = 'data-url value';

    if (refDomNode.is('li') && refDomNode.hasClass('edition-label')) {
        urlAttribute = 'value';
    } else if (
        refDomNode.is('span') &&
        $(refDomNode).closest('a[href]').length > 0
    ) {
        urlAttribute = 'href value';
        actualDomNode = refDomNode.closest('a[href]');
    }

    var actualUrl = isSiblingAttribute(actualDomNode) ? url : url; // TO-DO: change URL based on sibling

    if (actualUrl) {
        urlAttribute.split(' ').forEach((urlAttr) => {
            actualDomNode.attr(urlAttr, url);
        });
    } else {
        actualDomNode.removeAttr(urlAttribute);
    }
}

function setBuyableAndUrlForAttribute(index, element) {
    if (!this) return;

    var attributesOnThePage = this.attributesOnThePage;
    var attr = this.attr;

    if (!attributesOnThePage || !attr) return;

    var $element = $(element);
    var attributeValueOnElement = $element.attr('data-attr-value'); // need unparsed attr value here

    let filteredData = $('[data-attr-combos]').data('attr-combos');
    if (!filteredData) return;

    const isSwatchable = $(`[data-attr='${attr}']`).hasClass(
        'swatch-attribute'
    );
    let filteredDataForCurrentDomNode;

    if (isSwatchable) {
        const buyableElements = filteredData.filter(
            (i) => i[attr] === attributeValueOnElement && i.buyable
        );
        filteredDataForCurrentDomNode =
            buyableElements.length > 0 && buyableElements[0];
    } else {
        attributesOnThePage
            .filter((i) => i !== attr)
            .forEach((selectedAttr) => {
                filteredData = filteredData.filter(
                    (i) =>
                        i[selectedAttr] === getSelectionFunction[selectedAttr]()
                );
            });
        filteredDataForCurrentDomNode = filteredData.find(
            (i) => i[attr] === attributeValueOnElement
        );
    }

    if (filteredDataForCurrentDomNode) {
        const isCombinationBuyable = filteredDataForCurrentDomNode.buyable;

        if (isCombinationBuyable) {
            setBuyable($element, true);
        } else {
            setBuyable($element, false);
        }

        var urlType = isSiblingAttribute($element) ? 'x' : 'y';
        setUrl(
            $element,
            filteredDataForCurrentDomNode.url
                ? filteredDataForCurrentDomNode.url[urlType]
                : null
        );
    } else {
        setBuyable($element, false);
        setUrl($element, null);
    }
}

/**
 * Uses global variables
 * For any of users' most recent click
 * redraws the other attributes on the page
 * to indicate whether that combination is buyable or not
 */
function setBuyableAndUrlForSelection() {
    var attributesOnThePage = getAttributesOnThePage();
    attributesOnThePage.forEach(function (attr) {
        $.each(
            getAllDomNodesForAttribute(attr),
            setBuyableAndUrlForAttribute.bind({
                attributesOnThePage: attributesOnThePage,
                attr: attr
            })
        );
    });
}

function setAttributeOnClick(event) {
    if (
        !event ||
        !event.target ||
        event.target.getAttribute('selected') === 'selected'
    )
        return;

    var $target = $(event.target).closest('[data-attr-value]');
    // if event.target is pointing to select element then find the option which is selected
    if (!$target.length) {
        $target = $(event.target).find('option:selected');
    }
    if (!$target) return;

    var $attr = $target.closest('[data-attr]');

    if (!$attr) return;
    var attr = $attr.data('attr');

    if (!attr || !getSelectionFunction[attr]) return;

    var $currentSelectedAttr = $attr.find('.selected[data-attr-value]');
    $currentSelectedAttr.removeClass('selected');
    $currentSelectedAttr.attr('selected', null);

    $target.addClass('selected');
    $target.attr('selected', 'selected');
    if ($target.hasClass('not-buyable')) {
        var $addToCartButton = $('button.add-to-cart');
        $addToCartButton.text(getButtonLabelByState('notAvailable'));
        $addToCartButton.addClass('disabled');
    }

    setBuyableAndUrlForSelection();
    // setAttributeLabelsToSelection(); // TO-DO
    // setValidAttributesBasedOnSelection(); // TO-DO
}

/**
 * Set attribute label
 * @param {jQuery} $target target element where the attribute value to be added
 * @param {string} attributeDisplayValue display value to update in label
 */
function setAttributeLabel($target, attributeDisplayValue) {
    var $attributeLabel = $target.find('.attribute-value');
    $attributeLabel.text(attributeDisplayValue);
}

/**
 * Set all attributes label to what is currently selected
 */
function setAttributeLabelsToSelection() {
    // Trim all the label names
    $.each($('.attribute .attribute-label'), function (index, element) {
        var el = $(element);
        if (el && el.text()) {
            el.text(el.text().trim());
        }
    });

    if (isBuyBoxOnPDPEnabled === 'true') {
        $.each(
            getAttributesOnThePage().filter((i) => i !== 'condition'),
            function (index, attr) {
                const selectionFunction = getSelectionFunction[attr];
                if (selectionFunction) {
                    const currentlySelectedValue = selectionFunction();
                    if (currentlySelectedValue) {
                        const targetElement = $(
                            `[data-attr-value="${currentlySelectedValue}"]`
                        ).parents('.attribute');
                        const displayValue = $(
                            `[data-attr-value="${currentlySelectedValue}"]`
                        ).data('attr-display-value');
                        if (displayValue) {
                            setAttributeLabel(targetElement, displayValue);
                        }
                    }
                }
            }
        );

        // Special case for condition attribute as DOM structure is different
        var selectedCondition = $('.condition-attribute')
            .find('.selected, [selected]')
            .attr('data-attr-value');
        if (selectedCondition) {
            if (selectedCondition.trim() === 'Certified-Refurbished') {
                // special case for this one string alone because button label appears unhyphenated
                selectedCondition = 'Certified Refurbished';
            }
            var targetElement = $('.condition-attribute');
            setAttributeLabel(targetElement, ` ${selectedCondition}`);
        }
    }
}

/**
 * wrapper fn for showing and hiding. Should gradually use this funcf
 * until all hide/show is standardized
 * @param {jQuery} $elem element to show
 */
function show($elem) {
    $elem.removeClass('d-none');
}

/**
 * wrapper fn to hidin element
 * @param {jQuery} $elem Element to hide
 */
function hide($elem) {
    $elem.addClass('d-none');
}

/**
 * get cookie by name
 * @param {string} name - Cookie name
 * @return {string} - Cookie value
 */
function getCookie(name) {
    var value = `; ${document.cookie} ;`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts[1].substr(0, parts[1].indexOf(';')).replace(/"/g, '');
    }
    return null;
}

/**
 * reset price DOM
 */
function resetPrices() {
    var $redesignPriceinCart = $('.map-pricing-redesign');
    // var $productUnavailable = $('.product-unavailable-redesign');
    var $priceUpdate = $('.price-update');
    var $propointUpsellmessage = $('.propoints-upsell-message');

    $priceUpdate.empty();
    hide($priceUpdate);
    hide($redesignPriceinCart);
    hide($propointUpsellmessage);
    // if (response && response.product && response.product.isMasterInStock) {
    //     hide($productUnavailable);
    // } else {
    //     $productUnavailable.removeClass('d-none');
    // }
}

/**
 * reset Fulfillment flags
 */
function resetFulfillmentFlags() {
    // check fulfillment option eligibility default
    homeDeliveryEligible = true;
    sameDayDeliveryEligible = true;
    instoreDeliveryEligible = true;
    isDigitalProduct = false;

    // check fulfillment option availability default
    homeDeliveryAvailable = false;
    sameDayDeliveryAvailable = false;
    instoreDeliveryAvailable = false;
}

/**
 * Changes the unavailable state of a product
 * @param {setUnavailable} boolean
 */
function changeUnavailableState(setUnavailable) {
    // if (setUnavailable) {
    //     $('body').addClass('combination-unavailable');
    //     ['.price-update', '.prices', '.propoints-upsell-message', '.cart-and-ipay', '.oos-notify-me', 'promotions-redesign'].forEach(selector => {
    //         $(selector + ':not(.d-none)').addClass('d-none combination-unavailable');
    //     });
    //     $('.product-unavailable-redesign').removeClass('d-none');
    //     $('.oos-notify-me').addClass('d-none');
    //     $('.map-pricing-redesign').addClass('d-none');
    //     resetPrices();
    // } else {
    //     $('body').removeClass('combination-unavailable');
    //     $('.d-none.combination-unavailable').removeClass('d-none combination-unavailable');
    //     $('.product-unavailable-redesign').addClass('d-none');
    //     $('.map-pricing-redesign').removeClass('d-none');
    // }
}

/**
 * When feature flag is enabled
 * adds a cross to appropriate items to indicate to user
 * whether selection is valid or not
 */
function setValidAttributesBasedOnSelection() {
    if (isBuyBoxOnPDPEnabled === 'true') {
        $('body').on(
            'change',
            '.select-edition, .select-platform, .select-size',
            function (event) {
                const selectedCategory =
                    $(event.target).parents('[data-attr]').attr('data-attr') ||
                    $(event.target)
                        .parents('[data-sibling-value]')
                        .attr('data-sibling-value');
                const selectedValue = $(event.target)
                    .find('option')
                    .filter(':selected')
                    .attr('data-attr-value');
                const urlType = isSiblingAttribute(event.target) ? 'x' : 'y';

                let filteredData = $('[data-attr-combos]').data('attr-combos');
                if (!filteredData) return;
                filteredData = filteredData.filter(
                    (i) => i[selectedCategory] === selectedValue
                );

                getAttributesOnThePage()
                    .filter((i) => i !== selectedCategory)
                    .forEach((selectedAttr) => {
                        filteredData = filteredData.filter(
                            (i) =>
                                i[selectedAttr] ===
                                getSelectionFunction[selectedAttr]()
                        );
                    });
                window.pdpBuyBox = {};

                if (filteredData.length) {
                    const filteredItem = filteredData[0];
                    const selectedUrl = filteredItem.url
                        ? filteredItem.url[urlType]
                        : '';
                    const isSibling = filteredItem.isSibling;
                    const isVariant = filteredItem.isVariant;

                    window.pdpBuyBox = {
                        selectedUrl: selectedUrl,
                        isSibling: isSibling,
                        isVariant: isVariant
                    };
                }

                // if (!window.pdpBuyBox || !window.pdpBuyBox.selectedUrl || window.pdpBuyBox.selectedUrl === '') {
                //     changeUnavailableState(true);
                //     setAttributeOnClick(event);
                // } else if ($('body.combination-unavailable').length) {
                changeUnavailableState(false);
                setBuyableAndUrlForSelection();
                // }
            }
        );

        $('body').on(
            'click',
            '.attribute .options-select, .attribute .card, .attribute .color-value, .attribute .edition-value',
            function (event) {
                const selectedCategory = $(event.target)
                    .parents('[data-attr]')
                    .attr('data-attr');
                const selectedValue = $(event.target)
                    .closest('[data-attr-value]')
                    .attr('data-attr-value');
                const urlType = isSiblingAttribute(event.target) ? 'x' : 'y';

                let filteredData = $('[data-attr-combos]').data('attr-combos');
                if (!filteredData) return;
                filteredData = filteredData.filter(
                    (i) => i[selectedCategory] === selectedValue
                );

                getAttributesOnThePage()
                    .filter((i) => i !== selectedCategory)
                    .forEach((selectedAttr) => {
                        filteredData = filteredData.filter(
                            (i) =>
                                i[selectedAttr] ===
                                getSelectionFunction[selectedAttr]()
                        );
                    });
                window.pdpBuyBox = {};

                if (filteredData.length) {
                    const filteredItem = filteredData[0];
                    const selectedUrl = filteredItem.url
                        ? filteredItem.url[urlType]
                        : '';
                    const isSibling = filteredItem.isSibling;
                    const isVariant = filteredItem.isVariant;

                    window.pdpBuyBox = {
                        selectedUrl: selectedUrl,
                        isSibling: isSibling,
                        isVariant: isVariant
                    };
                }

                if (
                    !window.pdpBuyBox ||
                    !window.pdpBuyBox.selectedUrl ||
                    window.pdpBuyBox.selectedUrl === ''
                ) {
                    changeUnavailableState(true);
                    setAttributeOnClick(event);
                } else if ($('body.combination-unavailable').length) {
                    changeUnavailableState(false);
                    setBuyableAndUrlForSelection();
                }
            }
        );
    }
}

/**
 * Generates html for promotions section
 * @param {array} promotions - list of promotions
 * @return {string} - Compiled HTML
 */
function getPromotionsHtml(allPromotions) {
    if (!allPromotions) {
        return '';
    }

    var html = '';

    allPromotions.forEach(function (promotion) {
        if (promotion && promotion.promotionClass !== 'SHIPPING') {
            html += '<div class="callout">' + promotion.calloutMsg + '</div>';
        }
    });

    return html;
}

function promoRow(promoId, activeOfferMsg, modalContent) {
    return (
        '<button data-target="#activePromoModal-' +
        promoId +
        '" data-toggle="modal"><span class="d-flex"><span class="deals-icon mr-1"></span><span class="text-left">' +
        activeOfferMsg +
        '</span></span><span class="chevron"></span></button>' +
        '<!-- Modal -->' +
        '<div class="modal fade activePromoModal" id="activePromoModal-' +
        promoId +
        '" role="dialog">' +
        '<div class="modal-dialog ">' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <div class="h2"><div class="icon"></div>' +
        activeOfferMsg +
        '</div>' +
        '    <button type="button" class="close pull-right" data-dismiss="modal"></button>' +
        '</div>' +
        '<div class="modal-body">' +
        modalContent +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>'
    );
}

/**
 * Generates html for promotions section
 * @param {array} promotions - list of promotions
 * @param {array} proPromotions - list of promotions
 * @param {Object} resources - list of resources
 * @param {integer} minShowPromotionLength - length of promotions on first load
 * @return {string} - Compiled HTML
 */
function getPromotionsRedesignHtml(
    allPromotions,
    resources,
    minShowPromotionLength
) {
    if (allPromotions.length === 0) {
        return '';
    }

    var callOutMsgCounter = 0;

    var promoLength = 0;
    for (var j = 0; j < allPromotions.length; j++) {
        var productPromotion = allPromotions[j];
        if (
            productPromotion &&
            productPromotion.calloutMsg &&
            productPromotion.promotionClass !== 'SHIPPING'
        ) {
            promoLength++;
        }
    }

    var promoRows = '';
    var promotionMsg = '';
    for (var i = 0; i < allPromotions.length; i++) {
        var promotion = allPromotions[i];
        // condition to check if 'calloutMsg' is available
        if (
            promotion &&
            promotion.calloutMsg &&
            promotion.promotionClass !== 'SHIPPING'
        ) {
            promotionMsg = promotion.promotionSummary
                ? promotion.promotionSummary
                : promotion.calloutMsg;
            var modalContent =
                `<div class="callout d-flex mt-2 flex-column">` +
                '<div>' +
                (promotion.calloutMsg
                    ? promotion.calloutMsg
                    : promotion.promotionSummary) +
                '</div>' +
                '<a href="/search/?pmid=' +
                promotion.id +
                '" class="btn btn-outline-secondary text-center mt-2">View All Products</a>' +
                '</div>';

            promoRows += promoRow(promotion.id, promotionMsg, modalContent);

            ++callOutMsgCounter;
        }
    }

    // no active offers.
    return callOutMsgCounter === 0 ? '' : promoRows;
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {boolean} isOptionClicked - Warranty recommendation clicked
 */
function processBoxSelectionValues(attr, $productContainer, isOptionClicked) {
    const $allAttributes = $productContainer.find(
        '[data-attr="' +
            attr.id +
            '"] .condition-attribute-card[data-attr-value]'
    );
    $allAttributes.removeClass('selected');

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find(
            '[data-attr="' +
                attr.id +
                '"] .condition-attribute-card[data-attr-value="' +
                attrValue.value +
                '"]'
        );

        if (attrValue.selected) {
            $attrValue.addClass('selected');
        } else {
            $attrValue.removeClass('selected');
        }

        if (attrValue.url) {
            $attrValue.data('url', attrValue.url);
        }

        if (attrValue.selectedVariantId) {
            $attrValue.data(
                'condition-selected-variant-id',
                attrValue.selectedVariantId
            );
        }

        if (attrValue.price && attrValue.price.html) {
            var $priceSelector = $attrValue.find('.condition-prices div.price');
            if ($priceSelector.length) {
                $priceSelector.replaceWith(attrValue.price.html);
            }

            if (
                $productContainer.length &&
                $productContainer.hasClass('product-detail-redesign') &&
                !isOptionClicked
            ) {
                var $priceUpdate = $('.price-update');
                var $priceOriginal = $(
                    '.card.selected .condition-prices'
                ).html();
                $priceUpdate.html($priceOriginal);

                // rmeoving min height class after price update
                let $proPriceMessage = $('.pro-price-messaging');
                let $flexpayInfoWidget = $('.flexpayInfoWidget');
                $priceUpdate.removeClass('min-height');
                if ($proPriceMessage.length) {
                    $proPriceMessage.removeClass('min-height');
                }
                if ($flexpayInfoWidget.length) {
                    $flexpayInfoWidget.removeClass('min-height');
                }
            }
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');
        $attrValue.addClass(
            attrValue.selectable ? 'selectable' : 'unselectable'
        );
    });
}

/**
 * Updates Saving detail for each variant
 * @param {Object} attr - Attribute
 * @param {Object} resources - resources to print labels
 * @param {integer} savingViolatorPercentage - percentage violator to show saving
 */
function updateSavingDetails(attr, resources, savingViolatorPercentage) {
    var $newSavingSelector = $(document).find('.New-saving-detail');
    if ($newSavingSelector.length) {
        var attrNewDetails;
        var attrPreownedDetails;
        var attrRefurbishedDetails;
        var newSelected = false;
        var preownedSelected = false;
        var refurbishedSelected = false;

        attr.values.forEach(function (attrValue) {
            if (attrValue.id === 'New') {
                attrNewDetails = attrValue;
                if (attrValue.selected) {
                    newSelected = true;
                }
            } else if (attrValue.id === 'Pre-Owned') {
                attrPreownedDetails = attrValue;
                if (attrValue.selected) {
                    preownedSelected = true;
                }
            } else if (attrValue.id === 'Refurbished') {
                attrRefurbishedDetails = attrValue;
                if (attrValue.selected) {
                    refurbishedSelected = true;
                }
            }
        });

        var $preOwnedSavingSelector = $(document).find(
            '.Pre-Owned-saving-detail'
        );
        var $refurbishedSavingSelector = $(document).find(
            '.Refurbished-saving-detail'
        );
        var newListPrice;
        var newSalePrice;
        var preownedListPrice;
        var preownedSalePrice;
        var refurbishedListPrice;
        var refurbishedSalePrice;
        var saving;
        var savingPercentage;
        if (newSelected) {
            $preOwnedSavingSelector.empty();

            if (
                attrNewDetails &&
                attrNewDetails.price &&
                attrNewDetails.price.list &&
                attrNewDetails.price.list.value
            ) {
                newListPrice = attrNewDetails.price.list.value;
            }

            if (
                attrNewDetails &&
                attrNewDetails.price &&
                attrNewDetails.price.sales &&
                attrNewDetails.price.sales.value
            ) {
                newSalePrice = attrNewDetails.price.sales.value;
            }

            if ($preOwnedSavingSelector.length) {
                if (
                    attrPreownedDetails &&
                    attrPreownedDetails.price &&
                    attrPreownedDetails.price.sales &&
                    attrPreownedDetails.price.sales.value
                ) {
                    preownedSalePrice = attrPreownedDetails.price.sales.value;
                }
                if (newSalePrice > preownedSalePrice) {
                    if (!newListPrice) {
                        newListPrice = newSalePrice;
                    }
                    saving = newListPrice - preownedSalePrice;
                    savingPercentage = ((saving * 100) / newListPrice).toFixed(
                        2
                    );
                    $preOwnedSavingSelector.empty();
                    if (savingPercentage >= savingViolatorPercentage) {
                        $preOwnedSavingSelector.append(
                            '<span class="sale font-bold">' +
                                resources.save_additional +
                                saving.toFixed(2) +
                                ' | ' +
                                savingPercentage +
                                '% </span><span class="sale"> ' +
                                resources.save_indicator_on +
                                ' ' +
                                attrPreownedDetails.id +
                                '</span>'
                        );
                    } else {
                        $preOwnedSavingSelector.append(
                            '<span class="sale font-bold">' +
                                resources.save_additional +
                                saving.toFixed(2) +
                                '</span><span class="sale"> ' +
                                resources.save_indicator_on +
                                ' ' +
                                attrPreownedDetails.id +
                                '</span>'
                        );
                    }
                }
            }

            if ($refurbishedSavingSelector.length) {
                if (
                    attrRefurbishedDetails &&
                    attrRefurbishedDetails.price &&
                    attrRefurbishedDetails.price.sales &&
                    attrRefurbishedDetails.price.sales.value
                ) {
                    refurbishedSalePrice =
                        attrRefurbishedDetails.price.sales.value;
                }
                if (newSalePrice > refurbishedSalePrice) {
                    if (!newListPrice) {
                        newListPrice = newSalePrice;
                    }
                    saving = newListPrice - refurbishedSalePrice;
                    savingPercentage = ((saving * 100) / newListPrice).toFixed(
                        2
                    );
                    $refurbishedSavingSelector.empty();
                    if (savingPercentage >= savingViolatorPercentage) {
                        $refurbishedSavingSelector.append(
                            '<span class="sale font-bold">' +
                                resources.save_additional +
                                saving.toFixed(2) +
                                ' | ' +
                                savingPercentage +
                                '% </span><span class="sale"> ' +
                                resources.save_indicator_on +
                                ' ' +
                                attrRefurbishedDetails.id +
                                '</span>'
                        );
                    } else {
                        $refurbishedSavingSelector.append(
                            '<span class="sale font-bold">' +
                                resources.save_additional +
                                saving.toFixed(2) +
                                '</span><span class="sale"> ' +
                                resources.save_indicator_on +
                                ' ' +
                                attrRefurbishedDetails.id +
                                '</span>'
                        );
                    }
                }
            }
        } else if (preownedSelected) {
            $preOwnedSavingSelector.empty();

            if (
                attrNewDetails &&
                attrNewDetails.price &&
                attrNewDetails.price.list &&
                attrNewDetails.price.list.value
            ) {
                newListPrice = attrNewDetails.price.list.value;
            }

            if (
                attrNewDetails &&
                attrNewDetails.price &&
                attrNewDetails.price.sales &&
                attrNewDetails.price.sales.value
            ) {
                newSalePrice = attrNewDetails.price.sales.value;
            }

            if (
                attrPreownedDetails &&
                attrPreownedDetails.price &&
                attrPreownedDetails.price.list &&
                attrPreownedDetails.price.list.value
            ) {
                preownedListPrice = attrPreownedDetails.price.list.value;
            }

            if (
                attrPreownedDetails &&
                attrPreownedDetails.price &&
                attrPreownedDetails.price.sales &&
                attrPreownedDetails.price.sales.value
            ) {
                preownedSalePrice = attrPreownedDetails.price.sales.value;
            }

            if (
                preownedListPrice &&
                preownedSalePrice &&
                $preOwnedSavingSelector.length
            ) {
                saving = preownedListPrice - preownedSalePrice;
                savingPercentage = ((saving * 100) / preownedListPrice).toFixed(
                    2
                );
                $preOwnedSavingSelector.empty();
                if (savingPercentage >= savingViolatorPercentage) {
                    $preOwnedSavingSelector.append(
                        '<span class="sale on-sale-price">' +
                            resources.sale_indicator +
                            saving.toFixed(2) +
                            ' | ' +
                            savingPercentage +
                            '% off</span>'
                    );
                } else {
                    $preOwnedSavingSelector.append(
                        '<span class="sale on-sale-price">' +
                            resources.sale_indicator +
                            saving.toFixed(2) +
                            ' off</span>'
                    );
                }
            }
            if (
                !preownedListPrice &&
                preownedSalePrice &&
                $preOwnedSavingSelector.length
            ) {
                $preOwnedSavingSelector.empty();
            }
            if ($refurbishedSavingSelector.length) {
                if (
                    attrRefurbishedDetails &&
                    attrRefurbishedDetails.price &&
                    attrRefurbishedDetails.price.sales &&
                    attrRefurbishedDetails.price.sales.value
                ) {
                    refurbishedSalePrice =
                        attrRefurbishedDetails.price.sales.value;
                }
                if (newSalePrice > refurbishedSalePrice) {
                    if (!newListPrice) {
                        newListPrice = newSalePrice;
                    }
                    saving = newListPrice - refurbishedSalePrice;
                    savingPercentage = ((saving * 100) / newListPrice).toFixed(
                        2
                    );
                    $refurbishedSavingSelector.empty();
                    if (savingPercentage >= savingViolatorPercentage) {
                        $refurbishedSavingSelector.append(
                            '<span class="sale font-bold">' +
                                resources.save_additional +
                                saving.toFixed(2) +
                                ' | ' +
                                savingPercentage +
                                '</span><span class="sale"> ' +
                                resources.save_indicator_on +
                                ' ' +
                                attrRefurbishedDetails.id +
                                '</span>'
                        );
                    } else {
                        $refurbishedSavingSelector.append(
                            '<span class="sale font-bold">' +
                                resources.save_additional +
                                saving.toFixed(2) +
                                ' </span><span class="sale"> ' +
                                resources.save_indicator_on +
                                ' ' +
                                attrRefurbishedDetails.id +
                                '</span>'
                        );
                    }
                }
            }
        } else if (refurbishedSelected) {
            $refurbishedSavingSelector.empty();

            if (
                attrNewDetails &&
                attrNewDetails.price &&
                attrNewDetails.price.list &&
                attrNewDetails.price.list.value
            ) {
                newListPrice = attrNewDetails.price.list.value;
            }

            if (
                attrNewDetails &&
                attrNewDetails.price &&
                attrNewDetails.price.sales &&
                attrNewDetails.price.sales.value
            ) {
                newSalePrice = attrNewDetails.price.sales.value;
            }

            if (
                attrPreownedDetails &&
                attrPreownedDetails.price &&
                attrPreownedDetails.price.list &&
                attrPreownedDetails.price.list.value
            ) {
                preownedListPrice = attrPreownedDetails.price.list.value;
            }

            if (
                attrPreownedDetails &&
                attrPreownedDetails.price &&
                attrPreownedDetails.price.sales &&
                attrPreownedDetails.price.sales.value
            ) {
                preownedSalePrice = attrPreownedDetails.price.sales.value;
            }

            if ($refurbishedSavingSelector.length) {
                if (
                    attrRefurbishedDetails &&
                    attrRefurbishedDetails.price &&
                    attrRefurbishedDetails.price.list &&
                    attrRefurbishedDetails.price.list.value
                ) {
                    refurbishedListPrice =
                        attrRefurbishedDetails.price.list.value;
                }

                if (
                    attrRefurbishedDetails &&
                    attrRefurbishedDetails.price &&
                    attrRefurbishedDetails.price.sales &&
                    attrRefurbishedDetails.price.sales.value
                ) {
                    refurbishedSalePrice =
                        attrRefurbishedDetails.price.sales.value;
                }

                if (refurbishedListPrice && refurbishedSalePrice) {
                    saving = refurbishedListPrice - refurbishedSalePrice;
                    savingPercentage = (
                        (saving * 100) /
                        refurbishedListPrice
                    ).toFixed(2);
                    $refurbishedSavingSelector.empty();
                    if (savingPercentage >= savingViolatorPercentage) {
                        $refurbishedSavingSelector.append(
                            '<span class="sale on-sale-price">' +
                                resources.sale_indicator +
                                saving.toFixed(2) +
                                ' | ' +
                                savingPercentage +
                                '% off</span>'
                        );
                    } else {
                        $refurbishedSavingSelector.append(
                            '<span class="sale on-sale-price">' +
                                resources.sale_indicator +
                                saving.toFixed(2) +
                                ' off</span>'
                        );
                    }
                }
            }

            if (
                newSalePrice &&
                preownedSalePrice &&
                $preOwnedSavingSelector.length
            ) {
                if (newSalePrice > preownedSalePrice) {
                    if (!newListPrice) {
                        newListPrice = newSalePrice;
                    }
                    saving = newListPrice - preownedSalePrice;
                    savingPercentage = ((saving * 100) / newListPrice).toFixed(
                        2
                    );
                    $preOwnedSavingSelector.empty();
                    if (savingPercentage >= savingViolatorPercentage) {
                        $preOwnedSavingSelector.append(
                            '<span class="sale on-sale-price">' +
                                resources.save_indicator +
                                saving.toFixed(2) +
                                ' (' +
                                savingPercentage +
                                '%)</span><span class="sale on-sale-price">' +
                                resources.save_indicator_comparison +
                                '</span>'
                        );
                    } else {
                        $preOwnedSavingSelector.append(
                            '<span class="sale on-sale-price">' +
                                resources.save_indicator +
                                saving.toFixed(2) +
                                ' </span><span class="sale on-sale-price">' +
                                resources.save_indicator_comparison +
                                '</span>'
                        );
                    }
                }
            }
        }
    }
}
/**
 * Updates condition box with store pin if store has availability
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateConditionStoreAvailabilityIcon($productContainer) {
    var storePickupData = pdpInStore.methods.getStorePickupData();
    if (!storePickupData || !$productContainer || !$productContainer.length)
        return;

    var products = storePickupData.products || [];
    if (!products || !products.length) return;

    $('.condition-attribute-card').each(function () {
        var productId = $(this).data('condition-selected-variant-id');

        // first just unselect/hide all pins
        $(this).find('.storepickup-icon-container').addClass('d-none');

        if (productId) {
            for (var i = 0; i < products.length; i++) {
                var product = products[i];
                if (
                    String(product.id) === String(productId) &&
                    product.showPdpStoreLocatorIcon
                ) {
                    $(this)
                        .find('.storepickup-icon-container')
                        .removeClass('d-none');
                }
            }
        }
    });
}

/**
 * Updates store pickup button
 * @param {jQuery} response - response data
 */
function updateStorePickupButton(response) {
    if (!response) return;
    var $productContainer = response.container ? $(response.container) : null;
    var productId = response.productId || null;

    if (!productId && $productContainer && $productContainer.length) {
        productId = base.getPidValue($productContainer);
    }
    if (!productId) {
        return;
    }

    var resources = null;
    var $addToCartButton = $('.js-add-to-cart', response.$productContainer);
    var $applePay = $('button.apple-pay-pdp', response.$productContainer);
    var $storePickupButton = $(
        'button.btn-get-in-store-inventory',
        response.$productContainer
    );
    var $checkOtherStoresButton = $(
        'button.btn-check-other-stores',
        response.$productContainer
    );

    var inStockAtStore = false;
    var inStockCount = 0;
    var enableStorePickupButton = false;

    var availableOnline = $(
        'div.availability',
        response.$productContainer
    ).data('available');
    var readyToOrder = $('div.availability', response.$productContainer).data(
        'ready-to-order'
    );
    var isPreorder = $('div.availability', response.$productContainer).data(
        'is-preorder'
    );

    var enableAddToCartButton = availableOnline || readyToOrder;

    var storePickupData = pdpInStore.methods.getStorePickupData();
    var hopsEnabled = false;
    var bopsEnabled = false;
    var ispuEnabled = false;
    var sddEnabled = false;
    var hasVariantsAvailableForPickup = false;
    var hasVariantsAvailableForLookup = false;

    if (storePickupData) {
        hasVariantsAvailableForPickup =
            storePickupData.hasVariantsAvailableForPickup;
        hasVariantsAvailableForLookup =
            storePickupData.hasVariantsAvailableForLookup;
        resources = storePickupData.resources;
        if (
            Object.hasOwnProperty.call(storePickupData, 'storePickupDetails') &&
            storePickupData.storePickupDetails
        ) {
            var storePickupDetails = storePickupData.storePickupDetails;
            hopsEnabled = Object.hasOwnProperty.call(
                storePickupDetails,
                'hopsEnabled'
            )
                ? storePickupDetails.hopsEnabled
                : false;
            bopsEnabled = Object.hasOwnProperty.call(
                storePickupDetails,
                'bopsEnabled'
            )
                ? storePickupDetails.bopsEnabled
                : false;
            ispuEnabled = Object.hasOwnProperty.call(
                storePickupDetails,
                'ispuEnabled'
            )
                ? storePickupDetails.ispuEnabled
                : false;
            sddEnabled = Object.hasOwnProperty.call(
                storePickupDetails,
                'ispuEnabled'
            )
                ? storePickupDetails.sddEnabled
                : false;
        }
        var products = storePickupData.products || [];
        if (products.length) {
            for (var i = 0; i < products.length; i++) {
                var product = products[i];
                if (String(product.id) === String(productId)) {
                    if (product.inStock) {
                        inStockAtStore = true;
                        inStockCount = product.inStockCount;
                        if (hopsEnabled && product.allowHOPS) {
                            enableStorePickupButton = true;
                            enableAddToCartButton = true;
                        }
                        if (ispuEnabled && product.isISPU) {
                            enableStorePickupButton = true;
                            enableAddToCartButton = true;
                        }
                        if (bopsEnabled && product.allowBOPS) {
                            enableStorePickupButton = product.enablePickupBOPS;
                            enableAddToCartButton = true;
                        }
                        if (sddEnabled && product.allowSDD) {
                            enableStorePickupButton = product.enableDeliverySDD;
                            enableAddToCartButton = true;
                        }
                    }
                    break;
                }
            }
        }
    }

    $storePickupButton.attr('disabled', !enableStorePickupButton);

    // show check other stores button
    if (!enableStorePickupButton) {
        if (hasVariantsAvailableForPickup || hasVariantsAvailableForLookup) {
            $storePickupButton.addClass('d-none');
            var checkStoresButtonLabel =
                resources && resources.checkOtherStores
                    ? resources.checkOtherStores
                    : 'Check Other Stores';
            if (!hasVariantsAvailableForPickup) {
                checkStoresButtonLabel =
                    resources && resources.checkStoreInventory
                        ? resources.checkStoreInventory
                        : 'Check Store Inventory';
            }
            $checkOtherStoresButton.empty().html(checkStoresButtonLabel);
            $checkOtherStoresButton.removeClass('d-none');
        }
    } else {
        if (storePickupData.hasVariantsAvailableForPickup) {
            $storePickupButton.removeClass('d-none');
        }
        $checkOtherStoresButton.addClass('d-none');
    }

    $storePickupButton.data('in-stock', inStockAtStore);
    $storePickupButton.data('in-stock-count', inStockCount);

    $addToCartButton.attr('disabled', !enableAddToCartButton);
    $applePay.toggleClass('d-none');
    if (
        $('#hideOOSFulfillmentTile').val() === 'true' &&
        !enableAddToCartButton &&
        $('.delivery-out-of-stock.hide').length === 0
    ) {
        $('.shipping-options-available').addClass('d-none');
    }
    /**
     * if add to cart was disabled and now we are enabling, update messaging to indicate
     * it is only available for store pickup
     */
    if (!availableOnline) {
        var addToCartText =
            resources && resources.addToCart
                ? resources.addToCart
                : 'Add to Cart';
        if (enableAddToCartButton) {
            if (!isPreorder) {
                $addToCartButton.empty().html(addToCartText);
            }
            var storeStockMessage =
                resources && resources.inStockAtStore
                    ? resources.inStockAtStore
                    : 'This item is currently selected for store pickup';
            if (isPreorder) {
                storeStockMessage =
                    resources && resources.inStockAtStorePreorder
                        ? resources.inStockAtStorePreorder
                        : 'This pre-order is available for store pickup';
            }

            var storeAvailabilityMessage =
                '<div class="availability-in-stock">' +
                storeStockMessage +
                '</div>';
            $('.store-availability-msg', response.$productContainer)
                .empty()
                .html(storeAvailabilityMessage)
                .removeClass('d-none');
            $('.availability-msg', response.$productContainer).addClass(
                'd-none'
            );
        } else {
            addToCartText =
                resources && resources.notAvailable
                    ? resources.notAvailable
                    : 'Not Available';
            $addToCartButton.empty().html(addToCartText);
            $('.availability-msg', response.$productContainer).removeClass(
                'd-none'
            );
            $('.store-availability-msg', response.$productContainer).addClass(
                'd-none'
            );
        }
        updateFulfillment(false);
    } else {
        var addToCartText =
            resources && resources.addToCart
                ? resources.addToCart
                : 'Add to Cart';

        if (!enableAddToCartButton) {
            addToCartText =
                resources && resources.notAvailable
                    ? resources.notAvailable
                    : 'Not Available';
        }

        $addToCartButton.empty().html(addToCartText);
    }
}

/**
 * Generate variation attribute based on data-sibling when usselectable sibling is selected
 * @param {string} variationKey variationKey from datasibling object
 * @param {Object} existingAttributes existing variation attribute object
 * @param {any} unselectable rerender happening for an unselectable combination
 * @returns {boolean} true/false
 */
function reRenderVariationAttrFromDataSibling(id) {
    const variationTemplateForSwatch = $(
        '#t-variation-attribute-swatch'
    ).html();
    const variationTemplateForCTA = $('#t-variation-attribute-cta').html();
    const variationAttributes = $('.product-detail').data('allAttr');

    if (!variationAttributes || !Object.keys(variationAttributes).length) {
        return false;
    }

    let attributesToRender = variationAttributes[id]
        ? variationAttributes[id].valuesArray
        : [];
    const attributes = [];

    switch (id) {
        case 'color': {
            const $colorSwatchContainer = $(
                '.attribute-swatches',
                '.swatch-attribute'
            );
            if ($colorSwatchContainer) {
                // Loop through each attribute and generate markup to inject inside the the attribute container
                attributesToRender.forEach((attribute) => {
                    const $attrExistsInDOM = $(
                        `[data-attr-value="${attribute.value}"]`,
                        $colorSwatchContainer
                    ).parent();
                    // detach from DOM and add into the array if already exists based on the variation attribute sequence
                    if ($attrExistsInDOM.length) {
                        attributes.push($attrExistsInDOM.detach());
                    } else {
                        attributes.push(
                            variationTemplateForSwatch
                                .replace(
                                    /{url}/g,
                                    attribute.images.swatch[0].url
                                )
                                .replace(
                                    /{alt}/g,
                                    attribute.images.swatch[0].alt
                                )
                                .replace(/{id}/g, attribute.value)
                                .replace(
                                    /{className}/g,
                                    attribute.value.toLowerCase()
                                )
                                .replace(
                                    /{displayValue}/g,
                                    attribute.displayValue
                                )
                        );
                    }
                });

                // if showmore button exists then move that to the last in the array
                const $showMoreButton = $(
                    '.showHiddenColor',
                    $colorSwatchContainer
                );
                if ($showMoreButton) {
                    attributes.push($showMoreButton.detach());
                }

                $colorSwatchContainer.append(attributes);
            }
            break;
        }
        case 'condition': {
            const $conditionCTAContainer = $(
                '.card-deck',
                '.condition-attribute'
            );
            if ($conditionCTAContainer) {
                // Loop through each attribute and generate markup to inject inside the the attribute container
                attributesToRender.forEach((attribute) => {
                    const $attrExistsInDOM = $(
                        `[data-attr-value="${attribute.value}"]`,
                        $conditionCTAContainer
                    );
                    // detach from DOM and add into the array if already exists based on the variation attribute sequence
                    if ($attrExistsInDOM.length) {
                        attributes.push($attrExistsInDOM.detach());
                    } else {
                        attributes.push(
                            variationTemplateForCTA
                                .replace(/{id}/g, id)
                                .replace(/{value}/g, attribute.value)
                                .replace(
                                    /{className}/g,
                                    attribute.value.toLowerCase()
                                )
                                .replace(
                                    /{displayValue}/g,
                                    attribute.displayValue.replace(
                                        /(Certified)/,
                                        '<strong>$1 </strong>'
                                    )
                                )
                        );
                    }
                });
                $conditionCTAContainer.append(attributes);
            }
            break;
        }
        default: {
            break;
        }
    }

    return true;
}
/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processSwatchValues(attr, $productContainer) {
    var $allAttributes = $productContainer.find(
        '[data-attr="' + attr.id + '"] [data-attr-value]'
    );
    $allAttributes.removeClass('selected').removeAttr('selected');

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find(
            '[data-attr="' +
                attr.id +
                '"] [data-attr-value="' +
                attrValue.value +
                '"]'
        );
        var $swatchAnchor = $attrValue.parent();
        var storePickupData = pdpInStore.methods.getStorePickupData();

        if (attrValue.selected) {
            $attrValue.addClass('selected').attr('selected', true);

            // check to see if store pickup conditions have changed
            if (
                storePickupData &&
                Object.hasOwnProperty.call(storePickupData, 'hasCondition') &&
                storePickupData.hasCondition &&
                Object.hasOwnProperty.call(
                    storePickupData,
                    'variationAttributes'
                ) &&
                Object.hasOwnProperty.call(
                    storePickupData.variationAttributes,
                    attr.id
                ) &&
                Object.hasOwnProperty.call(
                    storePickupData.variationAttributes[attr.id],
                    attrValue.value
                )
            ) {
                var conditions =
                    storePickupData.variationAttributes[attr.id][
                        attrValue.value
                    ];
                if (conditions.length) {
                    conditions = conditions.map(function (e) {
                        return '<strong>' + e + '</strong>';
                    });
                    $('.preferred-store-inventory-availability .conditions')
                        .empty()
                        .html(conditions.join(' & '));
                }
            }
        } else {
            $attrValue.removeClass('selected').attr('selected', false);
        }

        if (attrValue.url) {
            $swatchAnchor.attr('href', attrValue.url);
        } else {
            $swatchAnchor.removeAttr('href');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(
            attrValue.selectable ? 'selectable' : 'unselectable'
        );
    });
}

/**
 * Updates price labels on condition variants
 * @param {Object} attrs - Attribute
 */
function updateConditionPriceLabels(attr) {
    const determineLowestPrice = (variant) => {
        const priceExcludingPro =
            variant.price.salePriceExcludingPro &&
            variant.price.salePriceExcludingPro.value;
        const priceIncludingPro =
            variant.price.salePriceIncludingPro &&
            variant.price.salePriceIncludingPro.value;
        return priceIncludingPro
            ? Math.min(priceIncludingPro, priceExcludingPro)
            : priceExcludingPro;
    };

    const selectedCondition = attr.values.find((value) => value.selected);
    const selectedPrice = determineLowestPrice(selectedCondition);

    if (selectedPrice) {
        attr.values.forEach((value) => {
            const conditionLabel = $('.condition-attribute').find(
                `[data-condition-selected-variant-id='${value.selectedVariantId}'] .condition-price`
            );
            if (value.selected) {
                conditionLabel.text(`$${selectedPrice.toFixed(2)}`);
                // ZipPay Information Widget price update
                $('quadpay-widget-v3').prop('amount',`$${selectedPrice.toFixed(2).replace('$','').replace(',','')}`)
            } else {
                const priceDiff = determineLowestPrice(value) - selectedPrice;
                if (priceDiff) {
                    conditionLabel.text(
                        priceDiff < 0
                            ? `-$${Math.abs(priceDiff).toFixed(2)}`
                            : `+$${priceDiff.toFixed(2)}`
                    );
                }
            }
        });
    }
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} resources - resources to print labels
 * @param {integer} savingViolatorPercentage - percentage violator to show saving
 * @param {boolean} isOptionClicked - Warranty recommendation clicked
 * @param {boolean} variationAttrSelected - truthy value is it is a variation, else return false
 */
function updateAttrs(
    attrs,
    $productContainer,
    resources,
    savingViolatorPercentage,
    isOptionClicked,
    variationAttrSelected
) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];
    var attrsWithBoxSelection = ['condition'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer);
        } else if (attrsWithBoxSelection.indexOf(attr.id) > -1) {
            processBoxSelectionValues(attr, $productContainer, isOptionClicked);
            updateSavingDetails(attr, resources, savingViolatorPercentage);
            updateConditionStoreAvailabilityIcon($productContainer);
            updateConditionPriceLabels(attr);
        } else {
            base.processNonSwatchValues(attr, $productContainer);
        }
        // rerender variation attribute with delta.
        if (!variationAttrSelected && isBuyBoxOnPDPEnabled === 'true') {
            reRenderVariationAttrFromDataSibling(attr.id);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var additionalValue = '';
    var priceBoxValue = '';
    var customValue = '';
    var availabilityMessages = response.product.availability.messages;
    var additionalMessages = response.product.availability.additionalmessages;
    var priceBoxMessages = response.product.additionalPriceBoxMessages;
    var customMessages = response.product.customMessages;
    var ctaText = response.product.availability.buttonText;
    var ctaTextStore = response.product.availability.buttonTextStore;
    if (!response.product.readyToOrder) {
        var unselectedMessage = response.product.unselectedVariationAttributes
            ? response.product.unselectedVariationAttributes
            : response.resources.info_selectforstock;
        if (unselectedMessage === 'ALL_ATTRS_SELECTED') {
            unselectedMessage = response.resources.info_notavailable_button;
            availabilityValue =
                '<div>' + response.resources.info_notavailable + '</div>';
        } else {
            availabilityValue = '<div>' + unselectedMessage + '</div>';
        }
        ctaText = unselectedMessage;
        ctaTextStore = unselectedMessage;
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue +=
                '<div class="' +
                (response.product.availability.className
                    ? response.product.availability.className
                    : '') +
                '">' +
                message +
                '</div>';
        });
        additionalMessages.forEach(function (message) {
            additionalValue += '<li>' + message + '</li>';
        });
        priceBoxMessages.forEach(function (message) {
            priceBoxValue += '<li>' + message + '</li>';
        });
        customMessages.forEach(function (message) {
            customValue += '<li>' + message + '</li>';
        });
    }

    $($productContainer)
        .find('.btn-get-in-store-inventory')
        .data(
            'bops-flag',
            response.product && response.product.enablePickupBOPS
        );

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        additionalMessage: additionalValue,
        priceBoxMessage: priceBoxValue,
        customMessage: customValue,
        buttonText: ctaText,
        buttonTextStore: ctaTextStore,
        resources: response.resources
    });
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} options - Ajax response options from selecting a product option
 * @param {html} optionsHtml - the HTML to redraw product options
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(options, optionsHtml, $productContainer) {
    var $optionsContainer = $productContainer.find(
        '.product-options-container'
    );
    if ((!options || options.length === 0) && $optionsContainer.length > 0) {
        $optionsContainer.addClass('d-none');
    } else {
        $optionsContainer.removeClass('d-none');
        if (optionsHtml) {
            if ($('#primary-details-row .js-product-options').length) {
                if ($(optionsHtml).children().length) {
                    $optionsContainer.empty().html(optionsHtml);
                } else {
                    $optionsContainer.empty();
                }
            }
        } else {
            options.forEach(function (option) {
                var $optionEl = $productContainer.find(
                    '.product-option[data-option-id*="' + option.id + '"]'
                );
                option.values.forEach(function (value) {
                    var valueEl = null;
                    if (option.selectType && option.selectType === 'radio') {
                        valueEl = $optionEl.find(
                            'input[type=radio][data-value-id*="' +
                                value.id +
                                '"]'
                        );
                    } else {
                        valueEl = $optionEl.find(
                            'option[data-value-id*="' + value.id + '"]'
                        );
                    }
                    if (valueEl && value.url) {
                        valueEl.val(value.url);
                    }
                });
            });
        }

        // PDP Redesign - Warranty recommendation
        if (
            $('#primary-details-row .product-options-redesign').length &&
            options.length
        ) {
            var selectedOptionId = options[0].selectedValueId;
            var selectedOptionElement = $(
                '#primary-details-row .warranty-option[data-value-id=' +
                    selectedOptionId +
                    ']'
            );
            if (selectedOptionElement.length) {
                selectedOptionElement.prop('checked', true);
                selectedOptionElement.addClass('current');
            }
        }
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function updatePowerUpRewardsData(response, $productContainer) {
    if (!$('.product-detail').length) {
        return;
    }

    // Update product name
    if (response.product.productName) {
        var productName =
            (response.product.subtitle ? response.product.subtitle + ' ' : '') +
            response.product.productName;
        $productContainer.find('.product-name').empty().html(productName);
    }

    // Update add to cart button text
    var $purAddToCartButton = $('.pur-add-to-cart');
    if (response.product.tileCtaText) {
        $purAddToCartButton.html(response.product.tileCtaText);
    }

    // Update / Hide price callout message
    if (response.product.priceCalloutMessage) {
        $productContainer
            .find('.price-callout-message')
            .empty()
            .html(response.product.priceCalloutMessage);
        $productContainer.find('.price-callout-message').removeClass('d-none');
    } else {
        $productContainer.find('.price-callout-message').empty();
        $productContainer.find('.price-callout-message').addClass('d-none');
    }

    // update data attrs
    if (response.product.membershipType) {
        $purAddToCartButton.data('pur-type', response.product.membershipType);
    }
    if (response.product.tileCtaActionUrl) {
        $purAddToCartButton.data('url', response.product.tileCtaActionUrl);
    }
    if (response.product.id) {
        $purAddToCartButton.data('pid', response.product.id);
    }
}

/**
 * set product label as per each product variant
 * @param {Object} product variant product
 * @returns {Object} buttonlabels
 */
function setButtonLabelByProductAvailability(product) {
    let { bopisButtonText } = product.availability;
    buttonLabels = {
        addToCart: $('.add-to-cart-label').val(),
        notAvailable: $('.not-available-label').val(),
        seePriceInCart: bopisButtonText || $('.see-price-in-cart-label').val(),
        deliverIt: $('.deliver-it-label').val(),
        pickUpAtStore: $('.pickup-at-store-label').val()
    };

    return buttonLabels;
}

/**
 * get button label based on state like addtocart, notavailable
 * @param {string} type Button label type
 * @param {boolean} isStoreClosed determine deliver today based on store hours
 * @returns {any} string
 */
function getButtonLabelByState(type, isStoreClosed = true) {
    var deliverby = ['today'];
    var label = buttonLabels[type] || false;

    if (label && type === 'deliverIt' && !isStoreClosed) {
        label = `${label} ${deliverby[0]}`;
    }

    return label;
}

/**
 * update fulfillment block state (button, cart/ipay container, and PayPal container) based on fulfillment option status
 * @param {boolean} isStoreClosed flag to determine SDD label
 * @return {any} return if existing code
 */
function toggleProductPrimaryDetailsDisplay(isStoreClosed = false) {
    var $cartAndIpayContainer = $('div.cart-and-ipay');
    var $payPalInfo = $('div.paypal-bnpl-message');
    var $addToCartButton = $('button.add-to-cart');
    var $samedayDeliveryButton = $('.btn-same-day-delivery');
    var $checkAvailabilityButton = $('.btn-check-availability'); // 'verify address' CTA button

    let showAddtoCartButton = homeDeliveryAvailable || instoreDeliveryAvailable;
    let showSamedayDeliveryButton =
        sameDayDeliveryAvailable && !homeDeliveryAvailable;
    let showInStoreDeliveryButton =
        instoreDeliveryAvailable && !homeDeliveryAvailable;
    let fulfullmentOptionsNotAvailable =
        !homeDeliveryAvailable &&
        !sameDayDeliveryAvailable &&
        !instoreDeliveryAvailable &&
        !isDigitalProduct;
    let productNotAvailable =
        !homeDeliveryEligible &&
        !sameDayDeliveryEligible &&
        !instoreDeliveryEligible &&
        !isDigitalProduct;

    let isSDDPreSelected = $('.js-fulfilment-option-delivery').hasClass('selected');

    // if buybox is OFF then show addtocart and disable all other features
    if (isBuyBoxOnPDPEnabled !== 'true') {
        show($addToCartButton);
        hide($checkAvailabilityButton);
        hide($samedayDeliveryButton);
        if (fulfullmentOptionsNotAvailable) {
            $addToCartButton.text(getButtonLabelByState('notAvailable'));
        }
        return false;
    }

    // Hide all product details include CTA , fulilment options, purchase plans if product is not available
    if (productNotAvailable || !isProductInStock) {
        hide($checkAvailabilityButton);
        hide($samedayDeliveryButton);
        hide($payPalInfo);
        $addToCartButton.text(getButtonLabelByState('notAvailable'));
        return false;
    }

    // If no fullment options is available then show not available CTA
    if (fulfullmentOptionsNotAvailable) {
        show($addToCartButton);
        $addToCartButton.text(getButtonLabelByState('notAvailable'));
    }

    show($cartAndIpayContainer);
    show($payPalInfo);

    // Show 'Verify Address' (check availability CTA) when no address found and sameDayDeliveryEligible is true
    if (isCheckAvailability) {
        hide($addToCartButton);
        hide($samedayDeliveryButton);
        show($checkAvailabilityButton);
    } else {
        hide($checkAvailabilityButton);
    }

    // Show Add to Cart when address verified and home delivery or digital product is true
    if (showAddtoCartButton || showInStoreDeliveryButton || isDigitalProduct) {
        show($addToCartButton);
        hide($checkAvailabilityButton);

        if (showInStoreDeliveryButton) {
            $addToCartButton.text(getButtonLabelByState('addToCart'));
            $addToCartButton.addClass('pickUpAtStore');
        }
    }

    // Case when show SDD and hide both 'Add to Cart' AND 'Verify Address'
    if (showSamedayDeliveryButton && isSDDPreSelected)  {
        hide($addToCartButton);
        hide($checkAvailabilityButton);
        show($samedayDeliveryButton);
        $samedayDeliveryButton.text(
            getButtonLabelByState('addToCart', isStoreClosed)
        );
    } else {
        hide($samedayDeliveryButton);
    }



    // Case when SDD and NO in-store pick up (BOPS)
    if (showSamedayDeliveryButton && !showInStoreDeliveryButton) {
        hide($addToCartButton);
        show($samedayDeliveryButton);
        $samedayDeliveryButton.addClass('only-cta-option');
    }

    return false;
}

/**
 * updating delivery option details based on ajax response
 * @param {Object} response - response from Ajax call
 */
function updateSDDOption(response) {
    var $addressDetails = $('.selected-address-details');
    var $samedayDelivery = $('.same-day-delivery');
    var $optionCardTitle = $('.option-card-title');
    var $optionCardMessage = $samedayDelivery.find('.option-card-message');
    var $productStock = $samedayDelivery.find('.product-store-message');
    var $locationText = $('.default-location-text');
    var $addressLink = $('.change-address');
    var $deliveryFee = $samedayDelivery.find('.shipping-option-charges');
    var $addressText = $locationText.find('.address-text');
    var $addToCartButton = $('.cart-and-ipay button.add-to-cart');
    var $applePay = $('.cart-and-ipay button.apple-pay-pdp');
    var $sddTooltip = $('.sdd-tooltip');
    let $selectedShippingOption = $('#selectedShippingOption');
    var $fulfilmentButtonDelivery = $('.js-fulfilment-option-delivery');
    var $fulfilmentDeliveryStatus = $('.js-pdp-fulfillment-delivery-status');
    var $fulfilmentDeliveryStatusHolidayBOPSMessage = $(
        '.js-pdp-fulfillment-delivery-status'
    ).data('holidaybopsmessage');

    if (response.hideSDD) {
        $samedayDelivery.hide();
        return;
    }

    // for option card title
    if (response.isStoreClosed) {
        $optionCardTitle
            .find('.next-day-title')
            .text(response.resources.nextDayDeliveryLabel)
            .removeClass('hide');
        $optionCardTitle.find('.same-day-title').addClass('hide');
    } else {
        $optionCardTitle.find('.same-day-title').removeClass('hide');
        $optionCardTitle.find('.next-day-title').addClass('hide');
    }

    if (response.isProductAvailable === true) {
        $fulfilmentDeliveryStatus.text('Today');
        $fulfilmentButtonDelivery.removeClass('js-verify');
        $optionCardTitle
            .find('.as-soon-as')
            .text(response.resources.getByMessage)
            .removeClass('hide');
        $locationText.find('.no-delivery').addClass('hide');
        $deliveryFee.removeClass('hide');
        if ($selectedShippingOption.val() !== 'home') {
            $selectedShippingOption.val('delivery');
        }
        $optionCardMessage.find('.outOfStock').addClass('hide');
        $optionCardMessage.find('.unavailbleSDD').addClass('hide');
        $optionCardMessage.find('.inStock').removeClass('hide');

        if (response.isStoreClosed) {
            $optionCardMessage.find('.same-day').addClass('hide');
        } else {
            $samedayDelivery.find('.countdown-timer').text(response.timeLeft);
            $optionCardMessage.find('.same-day').removeClass('hide');
            $optionCardMessage.find('.next-day').addClass('hide');
        }
        $fulfilmentDeliveryStatus.text(response.resources.pickup_today);
    } else {
        $fulfilmentDeliveryStatus.text(response.resources.verify_address);
        $fulfilmentButtonDelivery.addClass('js-verify');
        $optionCardMessage.find('.next-day').addClass('hide');
        $optionCardMessage.find('.same-day').addClass('hide');
        $optionCardTitle.find('.as-soon-as').addClass('hide');
        $optionCardMessage.find('.inStock').addClass('hide');
        $locationText.find('.no-delivery').addClass('hide');
        $deliveryFee.addClass('hide');

        if (response.isStoreAvailable) {
            $locationText
                .find('.no-delivery')
                .text(response.resources.noStockAtAddress);
            $optionCardMessage.find('.outOfStock').removeClass('hide');
            $optionCardMessage.find('.unavailbleSDD').addClass('hide');
            if (!$fulfilmentDeliveryStatusHolidayBOPSMessage) {
                $fulfilmentDeliveryStatus.text(
                    response.resources.changeAddress
                );
            }
        } else {
            $locationText
                .find('.no-delivery')
                .text(response.resources.notAvailableAtAddressMessage);
            $optionCardMessage.find('.outOfStock').addClass('hide');
            $optionCardMessage.find('.unavailbleSDD').removeClass('hide');
            if (!$fulfilmentDeliveryStatusHolidayBOPSMessage) {
                $fulfilmentDeliveryStatus.text(
                    response.resources.changeAddress
                );
            }
        }

        reopenDeliveryModal();
        updateFulfillment(false);
    }

    if (response.nearBy === true) {
        $addressDetails.addClass('verify-link-active');
        $locationText.find('.nearby').removeClass('hide');
        $addressLink.find('.verify-link').removeClass('hide');
        $locationText.find('.deliverto').addClass('hide');
        $addressLink.find('.change-link').addClass('hide');
        $optionCardMessage.find('.next-day').addClass('hide');
        $optionCardMessage.find('.same-day').addClass('hide');
        $locationText
            .find('.no-delivery')
            .text(response.resources.checkAvailability)
            .removeClass('hide');
        $optionCardMessage.find('.outOfStock').addClass('hide');
        isCheckAvailability = true;
    } else {
        $addressDetails.removeClass('verify-link-active');
        $locationText.find('.deliverto').removeClass('hide');
        $locationText.find('.nearby').addClass('hide');
        $addressLink.find('.verify-link').addClass('hide');
        $addressLink
            .find('.change-link')
            .text(
                response.zipCode
                    ? response.zipCode
                    : response.addressMsg.substring(
                          response.addressMsg.length - 5
                      )
            )
            .removeClass('hide');
        $addressText.text(response.addressMsg).addClass('hide');
        $sddTooltip.addClass('hide');
        isCheckAvailability = false;

        if (
            response.isProductAvailable === true &&
            response.stock !== undefined &&
            response.stock !== ''
        ) {
            $productStock.html(response.stock);
            $productStock.removeClass('hide');
            $locationText.find('.deliverto').removeClass('hide');
            $optionCardMessage.find('.inStock').addClass('hide');
        } else {
            $productStock.addClass('hide');
            $locationText.find('.deliverto').removeClass('hide');

            if (response.isProductAvailable === true) {
                $optionCardMessage.find('.inStock').removeClass('hide');
            } else {
                $optionCardMessage.find('.inStock').addClass('hide');
            }
        }
    }

    if (
        $selectedShippingOption.val() !== 'home' &&
        $selectedShippingOption.val() !== 'store' &&
        isBuyBoxOnPDPEnabled !== 'true'
    ) {
        if (response.atcDisable) {
            $addToCartButton.attr('disabled', 'disabled');
            $addToCartButton.text(getButtonLabelByState('notAvailable'));
            $applePay.addClass('d-none');
        } else {
            $addToCartButton.removeAttr('disabled');
            $addToCartButton.text(getButtonLabelByState('addToCart'));
            $applePay.removeClass('d-none');
        }
    }

    sessionStorage.removeItem('storeSameDayDeliveryAddress');
}

/**
 * updating delivery option details based on ajax response
 * @param {Object} url - url from response
 * @param {Object} event - response from variant Ajax call
 * @param {boolean} sendLocalStorage - to send the local storage
 * @return {promise} return an ajax promise
 */
function getSDDResponse(url, event, sendLocalStorage) {
    if (!url) {
        return;
    }
    let sddObject = {
        sameDayDeliveryObject: null
    };
    if (sendLocalStorage) {
        if (localStorage.getItem('sameDayDeliveryObject')) {
            sddObject.sameDayDeliveryObject = localStorage.getItem(
                'sameDayDeliveryObject'
            );
        }
    }
    var $addToCartButton = $('button.add-to-cart');
    return $.ajax({
        url: url,
        method: 'POST',
        data: sddObject,
        success: function (response) {
            const { isStoreClosed, isProductAvailable, nearBy } = response;
            sameDayDeliveryAvailable = isProductAvailable || false;
            verifyAddress = nearBy || false;
            isStoreClosedForSameDayDeliver = isStoreClosed || false;
            updateSDDOption(response);

            if (isBuyBoxOnPDPEnabled === 'true') {
                toggleProductPrimaryDetailsDisplay(isStoreClosed);
            } else if (response.seePriceInCart && sameDayDeliveryAvailable) {
                $addToCartButton.text(getButtonLabelByState('seePriceInCart'));
            }

            if (
                event &&
                Object.hasOwnProperty.call(response, 'gtmData') &&
                response.gtmData
            ) {
                $('body').trigger('product:afterAddressFormSubmit', {
                    gtmData: response.gtmData
                });
            }
        }
    });
}

function getSDDResponseSynchronous(url, event, sendLocalStorage) {
    if (!url) {
        return;
    }
    let sddObject = {
        sameDayDeliveryObject: null
    };
    if (sendLocalStorage) {
        if (localStorage.getItem('sameDayDeliveryObject')) {
            sddObject.sameDayDeliveryObject = localStorage.getItem(
                'sameDayDeliveryObject'
            );
        }
    }
    var $addToCartButton = $('button.add-to-cart');
    $.ajax({
        url: url,
        method: 'POST',
        async: false,
        data: sddObject,
        success: function (response) {
            const { isStoreClosed, isProductAvailable, nearBy } = response;
            sameDayDeliveryAvailable = isProductAvailable || false;
            verifyAddress = nearBy || false;
            isStoreClosedForSameDayDeliver = isStoreClosed || false;
            updateSDDOption(response);

            if (isBuyBoxOnPDPEnabled === 'true') {
                toggleProductPrimaryDetailsDisplay(isStoreClosed);
            } else if (response.seePriceInCart && sameDayDeliveryAvailable) {
                $addToCartButton.text(getButtonLabelByState('seePriceInCart'));
            }

            if (
                event &&
                Object.hasOwnProperty.call(response, 'gtmData') &&
                response.gtmData
            ) {
                $('body').trigger('product:afterAddressFormSubmit', {
                    gtmData: response.gtmData
                });
            }
        }
    });
    return sameDayDeliveryAvailable;
}

/**
 * get store availability for selected variant product
 * @param {Object} product - response from Ajax call
 * @param {string} selectedVariantId - selected variant
 * @return {boolean} - store availability for selected variant
 */
function getStoreAvailability(product) {
    if (product && !product.id) {
        return false;
    }
    var storeData = product.allVariantsStoreAvailability;
    var variantIndex = storeData.findIndex((item) => item.id === product.id);
    var isStoreAvailable =
        product.allVariantsStoreAvailability[variantIndex].store_avaialability;
    return isStoreAvailable;
}

/**
 * update price DOM based on its availability
 * @param {Object} response - response from Ajax call
 * @param {boolean} isAvailable - availability of the product
 */
function updatePrices(response, isAvailable) {
    var $redesignPriceinCart = $('.map-pricing-redesign');
    var $productUnavailable = $('.product-unavailable-redesign');
    var $priceUpdate = $('.price-update');
    var $propointUpsellmessage = $('.propoints-upsell-message');

    if (isBuyBoxOnPDPEnabled === 'true') {
        hide($productUnavailable);
        if (response.product.seePriceInCart && response.product.hidePricePDP) {
            show($redesignPriceinCart);
            show($propointUpsellmessage);
        } else {
            show($priceUpdate);
            show($propointUpsellmessage);
        }
    } else if (response.product.seePriceInCart && response.product.hidePricePDP) {
            show($priceUpdate);
            show($propointUpsellmessage);
    }
}

function reopenDeliveryModal() {
    var verifyAddressModalActionUrl = $(
        'input[name="SDDVerifyAddressModalActionUrl"]'
    ).val();
    if (verifyAddressModalActionUrl === undefined) {
        var skuFromHiddenInput = $('input[name="sku-id"]').val();
        verifyAddressModalActionUrl =
            '/on/demandware.store/Sites-gamestop-us-Site/default/SameDayDelivery-VerifyAddressModal?source=pdp&amp;productId=' +
            skuFromHiddenInput;
    }

    sessionStorage.removeItem('storeSameDayDeliveryAddress');
}

/**
 * Handle visibility of fulfillment options in pdp page
 * @param {Object} response - response from Ajax call
 * @param {boolean} isInventoryOverriden - availability of the product
 */
function updateFulfillment(isInventoryOverriden) {
    var $productContainer = $('.product-detail');
    var $shippingOptions = $('.shipping-options-available', $productContainer);
    var $homeDelivery = $shippingOptions.find('.home-delivery');
    var $instoreDelivery = $shippingOptions.find('.instore-delivery');
    var $samedayDelivery = $shippingOptions.find('.same-day-delivery');
    var $fulfilmentButtonStore = $('.js-fulfilment-option-store');
    var $fulfilmentButtonDelivery = $('.js-fulfilment-option-delivery');
    var $fulfilmentButtonShip = $('.js-fulfilment-option-ship');
    var $fulfilmentButtons = $('.js-fulfilment-option');
    var $fulfilmentInput = $('.js-selectedFulfilmentOption');
    var $fulfilmentStatusStore = $('.js-pdp-fulfillment-store-status');
    var $fulfilmentStatusStoreHolidayBOPSMessage = $(
        '.js-pdp-fulfillment-store-status'
    ).data('holidaybopsmessage');
    var $fulfilmentStatusDelivery = $('.js-pdp-fulfillment-delivery-status');
    var $fulfilmentStatusDeliveryHolidayBOPSMessage = $(
        '.js-pdp-fulfillment-delivery-status'
    ).data('holidaybopsmessage');
    var $fulfilmentStatusShip = $('.js-pdp-fulfillment-ship-status');
    var $fulfilmentSelectedText = $('.js-fulfillment-selected');
    var fulfilmentUnavailableClass = 'unavailable';

    if (isInventoryOverriden) {
        $shippingOptions.addClass('d-none');
    } else if (
        !homeDeliveryEligible &&
        !sameDayDeliveryEligible &&
        !instoreDeliveryEligible
    ) {
        $shippingOptions.addClass('d-none');
    } else if (
        homeDeliveryEligible ||
        sameDayDeliveryEligible ||
        instoreDeliveryEligible
    ) {
        $shippingOptions.removeClass('d-none');
    }

    if (isProductInStock) {

        if (homeDeliveryEligible) {
            $homeDelivery.removeClass('d-none');
            $fulfilmentButtonShip.removeClass(fulfilmentUnavailableClass);
        } else {
            $fulfilmentButtonShip.addClass(fulfilmentUnavailableClass);
            $fulfilmentStatusShip.text('Not Available');
        }
        if (sameDayDeliveryEligible) {
            $samedayDelivery.removeClass('d-none');
            $fulfilmentButtonDelivery.removeClass(fulfilmentUnavailableClass);
            if (!$fulfilmentStatusDeliveryHolidayBOPSMessage) {
                $fulfilmentStatusDelivery.text('Today');
            }
        } else {
            $fulfilmentButtonDelivery.addClass(fulfilmentUnavailableClass);
            $fulfilmentStatusDelivery.text('Not Available');
        }
        if (instoreDeliveryEligible) {
            $instoreDelivery.removeClass('d-none');
            $fulfilmentButtonStore.removeClass(fulfilmentUnavailableClass);
        } else {
            $fulfilmentButtonStore.addClass(fulfilmentUnavailableClass);
            var storeText = $fulfilmentButtonStore.hasClass('js-outofstock')
                ? 'Find a Store'
                : 'Not Available';
            if (!$fulfilmentStatusStoreHolidayBOPSMessage) {
                $fulfilmentStatusStore.text(storeText);
            }
        }
    } else {
        $fulfilmentButtonShip.addClass(fulfilmentUnavailableClass);
        $fulfilmentStatusShip.text('Not Available');
        //EFEE-3753 - Disable BOPS and SDD if home delivery is not available (SFCC inventory unavailable)
        $fulfilmentButtonDelivery.addClass(fulfilmentUnavailableClass);
        $fulfilmentStatusDelivery.text('Not Available');

        $fulfilmentButtonStore.addClass(fulfilmentUnavailableClass);
        var storeText = 'Not Available';
        if (!$fulfilmentStatusStoreHolidayBOPSMessage) {
            $fulfilmentStatusStore.text(storeText);
        }
        var $addToCartButton = $('button.add-to-cart');
        $addToCartButton.attr('disabled', 'disabled');
        $('.pdp-delivery-label').addClass('d-none');
    }

    $fulfilmentButtons.removeClass('selected');
    $fulfilmentInput.val('');

    var setSelectedFullfilment = function (userPreference) {
        var isStoreDisable =
            $fulfilmentButtonStore.hasClass(fulfilmentUnavailableClass) ||
            $fulfilmentButtonStore.hasClass('js-outofstock');
        var isDeliveryDisable =
            $fulfilmentButtonDelivery.hasClass(fulfilmentUnavailableClass) ||
            $fulfilmentButtonDelivery.hasClass('js-verify');
        var isShipDisable = $fulfilmentButtonShip.hasClass(
            fulfilmentUnavailableClass
        );

        var setStorePreselected = function () {
            var text = $fulfilmentButtonStore.data('optionlabel');
            $fulfilmentSelectedText.text(text);
            $('.js-pdp-fullfilment-info-store').show();
            $fulfilmentInput.val('store');
            $fulfilmentButtonStore.addClass('selected');
        };

        var setDeliveryPreselected = function () {
            var text = $fulfilmentButtonDelivery.data('optionlabel');
            $fulfilmentSelectedText.text(text);
            $('.js-pdp-fullfilment-info-deliver').show();
            $fulfilmentInput.val('delivery');
            $fulfilmentButtonDelivery.addClass('selected');
        };

        var setShipPreselected = function () {
            var text = $fulfilmentButtonShip.data('optionlabel');
            $fulfilmentSelectedText.text(text);
            $('.js-pdp-fullfilment-info-ship').show();
            $fulfilmentInput.val('ship');
            $fulfilmentButtonShip.addClass('selected');
        };

        if (userPreference === 'ship') {
            if (!isShipDisable) {
                return setShipPreselected();
            } else if (!isStoreDisable) {
                return setStorePreselected();
            } else {
                return setDeliveryPreselected();
            }
        } else if (userPreference === 'delivery') {
            if (!isDeliveryDisable) {
                return setDeliveryPreselected();
            } else if (!isShipDisable) {
                return setShipPreselected();
            } else {
                return setStorePreselected();
            }
        } else {
            if (!isStoreDisable) {
                return setStorePreselected();
            } else if (!isShipDisable) {
                return setShipPreselected();
            } else {
                return setDeliveryPreselected();
            }
        }
    };

    // set users default fulfillment option
    $('.js-pdp-fullfilment-info').hide();
    if (isProductInStock) {
        var fulfillmentPreference =
        localStorage.getItem('gme-pref-fulfillment') || 'store';
        setSelectedFullfilment(fulfillmentPreference);
    }

}

/**
 * updating delivery option details based on ajax response
 * @param {Object} response - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {boolean} isOptionClicked - Warranty recommendation clicked
 * @param {boolean} isFastShippingNotAllowed - is fast shipping not allowed
 */
function updateDeliveryOptions(
    response,
    $productContainer,
    isOptionClicked,
    isFastShippingNotAllowed
) {
    var $shippingOptions = $('.shipping-options-available', $productContainer);
    var $addToCartButton = $('button.add-to-cart', $productContainer);
    var $availabilityMsg = $('.availability-msg', $productContainer);
    var $storeDetails = $('.selected-store-details', $productContainer);
    var $digitalRedesignMessage = $('.digital-redesign-messages');
    var $productAdditionalMessages = $('.product-additional-messages');
    var $instoreDeliveryInputRadio = $(
        '.instore-delivery input[type=radio]',
        $productContainer
    );
    var $gettingStarted = $('button#getting-started-btn');
    let $isBundledPrduct = $('#isBundledProduct');
    var $applePay = $('button.apple-pay-pdp', $productContainer);

    let $samedayDeliveryCont = $('.js-same-day-delivery', $productContainer);
    let $selectedShippingOption = $(
        '#selectedShippingOption',
        $productContainer
    );

    var $homeDelivery = $shippingOptions.find('.home-delivery');
    var $instoreDelivery = $shippingOptions.find('.instore-delivery');
    var $expectedDeliveryMessage = $('.option-card-message', $homeDelivery);

    resetFulfillmentFlags();
    setButtonLabelByProductAvailability(response.product);

    isProductInStock = response.product ? response.product.available : false;

    // update price and set available as true if any of the option available or product is digital
    updatePrices(
        response,
        homeDeliveryEligible ||
            sameDayDeliveryEligible ||
            instoreDeliveryEligible ||
            isDigitalProduct
    );

    $selectedShippingOption.val('');

    $productContainer.addClass('updated-shipping');

    if ($gettingStarted.length) {
        $addToCartButton = $gettingStarted;
    }

    // condition to check for shipping options and if varient has master product id
    if (
        $shippingOptions.length &&
        (response.product.masterProductID || response.product.isBundle)
    ) {
        $availabilityMsg.hide();
        // condition to check if the product is digital/non-digital
        if (!response.product.isDigitalProduct) {
            var $varientStoreInput = $(
                'input#storeDetail-' + response.product.id
            );
            var deliveryMessageArray = '';
            var sddUrl = null;

            isDigitalProduct = false;

            // setting message for delivery option
            if (response.product.availability.limitedstockmessage) {
                deliveryMessageArray =
                    response.product.availability.limitedstockmessage;
            }

            if (
                $samedayDeliveryCont.length &&
                response?.sameDayDelivery?.actionUrl
            ) {
                sddUrl = utils.appendParamToURL(
                    response.sameDayDelivery.actionUrl,
                    'pid',
                    response.product.id
                );
                $('.same-day-delivery.js-same-day-delivery').attr(
                    'data-actionurl',
                    sddUrl
                );
            }

            // setting pid, master product id ,condition for radio buttons
            // removing checked state from the options
            $selectedShippingOption
                .data('pid', response.product.id)
                .data('master-pid', response.product.masterProductID)
                .data('condition', response.product.productCondition);

            // updating same day delivery radio button
            if (
                response.sameDayDelivery !== undefined &&
                response.sameDayDelivery.isSDDEnable &&
                Object.hasOwnProperty.call(
                    response.product,
                    'isProductSDDEligible'
                ) &&
                response.product.isProductSDDEligible &&
                !response.product.backorder &&
                !response.product.isBundle &&
                !$isBundledPrduct.length
            ) {
                // check store availability of product variant to show SDD
                sameDayDeliveryEligible = getStoreAvailability(
                    response.product
                );

                // only call samedaydelivery if store has inventory
                if (sameDayDeliveryEligible) {
                    // identify SDD eligibility
                    getSDDResponse(sddUrl, null, true);
                }
            } else if (
                response.product.backorder ||
                response.product.isBundle ||
                $isBundledPrduct.length
            ) {
                sameDayDeliveryEligible = false;
                sameDayDeliveryAvailable = false;
            } else {
                sameDayDeliveryEligible = false;
                sameDayDeliveryAvailable = false;
            }

            // updating delivery radio button
            if (response.product.isDeliveryAllowed) {
                $('.js-pdp-fulfillment-ship-status').text(response.defaultDeliveryMessage);
                // Ship to home available
                if (
                    response.product.available &&
                    response.product.readyToOrder &&
                    !response.product.isInventoryOverriden
                ) {
                    // when product in stock for delivery
                    $selectedShippingOption.val('home');
                    $addToCartButton.removeAttr('disabled');
                    $applePay.removeClass('d-none');

                    homeDeliveryAvailable = true;
                    if (
                        $('#readDeliveryMsgFrmProdVariation').val() ===
                            'true' ||
                        isFastShippingNotAllowed ||
                        $('#isProtectedItem').val() === 'true' ||
                        $('#excludeGeoFastShip').val() === 'true'
                    ) {
                        var estimatedDateMessageArray = '';
                        if (
                            response.product.availability
                                .estimatedDateRangeMessage
                        ) {
                            estimatedDateMessageArray =
                                response.product.availability
                                    .estimatedDateRangeMessage;
                        }
                        if (estimatedDateMessageArray.length) {
                            $expectedDeliveryMessage.removeClass('hide');
                            $('.d-block', $homeDelivery).removeClass('hide');
                            $('.delivery-message', $homeDelivery).html(
                                estimatedDateMessageArray[0]
                            );
                            $expectedDeliveryMessage
                                .find('span')
                                .not('.delivery-unavailable')
                                .removeClass('hide');
                            $homeDelivery
                                .find('.delivery-out-of-stock')
                                .addClass('hide');
                        }
                    }
                    if (response.product.preOrderMessage) {
                        $('.d-block', $homeDelivery).removeClass('hide');
                        $('.delivery-message', $homeDelivery).text(
                            response.product.releaseDateMessage
                        );
                        var $deliveryMessage = $('.delivery-message');
                        if ($deliveryMessage.text().indexOf(':') > -1) {
                            var justTheDate = $deliveryMessage
                                .text()
                                .split(':')[1];
                            var getItMessage = $deliveryMessage
                                .text()
                                .split(':')[0];
                            $deliveryMessage.empty();
                            $deliveryMessage.html(
                                getItMessage +
                                    ' : <span> ' +
                                    justTheDate +
                                    '</span>'
                            );
                        }
                        $('.option-label-msg-normal').addClass('d-none');
                        $('.option-label-msg-preorder').removeClass('d-none');
                        $('.orderOption-label').addClass('d-none');
                        $('.orderOption-label-preorder').removeClass('d-none');
                    }

                    if (deliveryMessageArray.length) {
                        $homeDelivery
                            .find('.delivery-home-stock-msg')
                            .text(deliveryMessageArray[0])
                            .removeClass('hide');
                        if (deliveryMessageArray[0] === 'Limited Stock') {
                            $homeDelivery.find('.delivery-home-stock-msg').addClass('stock-orange');
                        }
                    }
                } else {
                    homeDeliveryEligible = false;
                    homeDeliveryAvailable = false;
                    $expectedDeliveryMessage.find('span').addClass('hide');
                    $homeDelivery
                        .find('.delivery-out-of-stock')
                        .removeClass('hide');
                    $expectedDeliveryMessage.removeClass('hide');
                }
            } else {
                $('.js-pdp-fulfillment-ship-status').text(
                    response.resources.not_available
                );
                homeDeliveryEligible = false;
                homeDeliveryAvailable = false;
                $expectedDeliveryMessage.find('span').addClass('hide');
                $homeDelivery.find('.delivery-unavailable').removeClass('hide');
                $expectedDeliveryMessage.removeClass('hide');
            }

            const isProductAvailable =
                response.product.available &&
                response.product.readyToOrder &&
                response.product.isDeliveryAllowed;
            // check for bops availability
            if (
                response.product.allowBOPS &&
                !response.product.backorder &&
                !response.product.isBundle &&
                !$isBundledPrduct.length
            ) {
                var $storeAddress = $(
                    '.product-store-address',
                    $productContainer
                );
                var $storeMessage = $(
                    '.product-store-message',
                    $instoreDelivery
                );
                var $storePickupMsg = $(
                    '.product-store-pickup-message',
                    $productContainer
                );
                var $nearestStoreMsg = $(
                    '.nearest-store-message',
                    $productContainer
                );
                var $storeUnavailableMsg = $(
                    '.store-unavailable-message',
                    $productContainer
                );
                var $atLabel = $('.unavailable-at', $productContainer);
                var $outOfStockStore = $(
                    '.outOfStockInstore',
                    $instoreDelivery
                );
                var $inStockStore = $('.inStockInstore', $instoreDelivery);
                var $pickToday = $('.pick-today', $instoreDelivery);
                var $pickTomorrow = $('.pick-tomorrow', $instoreDelivery);

                $storeDetails.removeClass('hide');

                var storeObj = '';
                var storeAddress = '';
                var stockMsg = '';

                $instoreDelivery.removeClass('d-none');
                $instoreDelivery.find('.store-unavailable').addClass('hide');
                $instoreDelivery.find('.free-label').removeClass('hide');
                $instoreDelivery.find('.promo-label').removeClass('hide');

                // show pickup tomorrow on store pickupe label
                $pickToday.addClass('hide');
                $pickTomorrow.removeClass('hide');
                if (
                    !$('.js-pdp-fulfillment-store-status').data(
                        'holidaybopsmessage'
                    )
                ) {
                    $('.js-pdp-fulfillment-store-status').text('Tomorrow');
                }

                if (
                    ($selectedShippingOption.val() === '' ||
                        $selectedShippingOption.val() === null) &&
                    $selectedShippingOption.val() !== 'home'
                ) {
                    $selectedShippingOption.val('store');
                }

                if (response.product.availability.bopisButtonText) {
                    $addToCartButton.text(
                        getButtonLabelByState('seePriceInCart')
                    );
                }

                // if Store ATP > 0 makes instore delivery true
                instoreDeliveryEligible = getStoreAvailability(
                    response.product
                );

                // if Store ATP > 0 and if near store avaiability is true then show
                // else hide instore delivery option.
                if (instoreDeliveryEligible && $varientStoreInput.length) {
                    storeObj = JSON.parse($varientStoreInput.data('json'));
                    storeAddress += storeObj.storeName
                        ? storeObj.storeName
                        : '';
                    stockMsg = storeObj.limitedStockMessage
                        ? storeObj.limitedStockMessage
                        : '';

                    instoreDeliveryAvailable = true;

                    if (storeObj.nearestStoreText) {
                        // update based on nearest store message
                        $nearestStoreMsg
                            .text(storeObj.nearestStoreText + ':')
                            .removeClass('hide');
                        $('.default-store-text', $productContainer).addClass(
                            'hide'
                        );
                    } else {
                        $nearestStoreMsg.text('').addClass('hide');
                        $('.default-store-text', $productContainer).removeClass(
                            'hide'
                        );
                    }

                    var sName = storeAddress
                        ? storeAddress.replace(' - GameStop', '')
                        : 'Select a store';
                    $storeAddress.text(sName).removeClass('hide');
                    $storeAddress.data('store-id', storeObj.nearestStoreId)
                    $storeMessage.text(stockMsg);
                    $storePickupMsg.html(storeObj.InStorePickUpMessage);

                    if (response.product.preorder) {
                        if (response.product.availability.bopisOrderByDate) {
                            $storePickupMsg
                                .find('.bydate')
                                .text(
                                    response.product.availability
                                        .bopisOrderByDate
                                );
                            $storePickupMsg.removeClass('hide');
                        } else if (
                            response.product.availability.bopisOrderAfterDate
                        ) {
                            $storePickupMsg
                                .find('.afterdate')
                                .text(
                                    response.product.availability
                                        .bopisOrderAfterDate
                                );
                            $instoreDelivery
                                .find('input[type=radio]')
                                .attr('disabled', 'disabled');
                            $storePickupMsg.removeClass('hide');
                        }
                    } else if (storeObj.InStorePickUpMessageSameDay) {
                        $storePickupMsg
                            .find('.countdown-timer')
                            .text(storeObj.InStorePickUpMessageSameDay);
                        $storePickupMsg.find('.same-day').removeClass('hide');
                        $storePickupMsg.removeClass('hide');

                        // show pickup today on store pickupe label
                        $pickToday.removeClass('hide');
                        $pickTomorrow.addClass('hide');
                        if (
                            !$('.js-pdp-fulfillment-store-status').data(
                                'holidaybopsmessage'
                            )
                        ) {
                            $('.js-pdp-fulfillment-store-status').text('Today');
                        }
                        $storePickupMsg.removeClass('hide');
                    } else if (storeObj.InStorePickUpMessageNextDay) {
                        $storePickupMsg.removeClass('hide');
                        if (
                            !$('.js-pdp-fulfillment-store-status').data(
                                'holidaybopsmessage'
                            )
                        ) {
                            $('.js-pdp-fulfillment-store-status').text(
                                'Tomorrow'
                            );
                        }
                    }

                    $storeUnavailableMsg.addClass('hide');
                    $atLabel.addClass('hide');
                    $('.pdp-delivery-option-button--store').removeClass(
                        'js-outofstock'
                    );
                    $outOfStockStore.addClass('hide');
                    $inStockStore.removeClass('hide');
                    $selectedShippingOption.data(
                        'storeId',
                        storeObj.nearestStoreId
                    );
                    $selectedShippingOption.data(
                        'inventory',
                        storeObj.inventoryAvailable
                    );

                    if (storeObj.limitedStockMessage) {
                        $inStockStore.addClass('hide');
                    } else {
                        $inStockStore.removeClass('hide');
                    }

                    // Enabling add to cart button if store is available
                    $addToCartButton.removeAttr('disabled');
                    if (
                        isBuyBoxOnPDPEnabled === 'true' &&
                        !isProductAvailable
                    ) {
                        $addToCartButton.text(
                            getButtonLabelByState('addToCart')
                        );
                    } else {
                        $addToCartButton.text(
                            $addToCartButton.data('buttonText')
                        );
                    }

                    $applePay.removeClass('d-none');
                    if (response.product.seePriceInCart) {
                        if (response.product.preorder) {
                            $addToCartButton.text(
                                response.product.availability.buttonText
                            );
                        } else {
                            $addToCartButton.text(
                                getButtonLabelByState('seePriceInCart')
                            );
                        }
                    }
                } else {
                    $('.js-pdp-fulfillment-store-status').text(
                        response.resources.find_store
                    );
                    $storeAddress.text('').addClass('hide');
                    $storeMessage.text('');
                    $nearestStoreMsg.text('');

                    $storeUnavailableMsg.removeClass('hide');
                    $atLabel.removeClass('hide');
                    $('.pdp-delivery-option-button--store').addClass(
                        'js-outofstock'
                    );
                    $outOfStockStore.removeClass('hide');
                    $inStockStore.addClass('hide');
                    $('.default-store-text', $productContainer).addClass(
                        'hide'
                    );
                    $('.instore-store-text').addClass('hide');

                    if ($('input#defaultStore').length) {
                        var name = $('input#defaultStore').val()
                            ? $('input#defaultStore')
                                  .val()
                                  .replace(' - GameStop', '')
                            : 'Select a store';
                        $storeUnavailableMsg.find('.store-name').text(name);
                    }

                    if (!isProductAvailable) {
                        $addToCartButton.attr('disabled', 'disabled');
                        $addToCartButton.text(
                            getButtonLabelByState('notAvailable')
                        );
                        $applePay.addClass('d-none');
                        if (
                            $('#hideOOSFulfillmentTile').val() === 'true' &&
                            $('.delivery-out-of-stock.hide').length === 0
                        ) {
                            $('.shipping-options-available').addClass('d-none');
                        }
                    } else if (
                        $instoreDeliveryInputRadio.is(':checked') &&
                        isOptionClicked
                    ) {
                        // TODO: Probably this code is not used anymore
                        $addToCartButton.attr('disabled', 'disabled');
                        $addToCartButton.text(
                            getButtonLabelByState('notAvailable')
                        );
                        $applePay.addClass('d-none');
                        if (
                            $('#hideOOSFulfillmentTile').val() === 'true' &&
                            $('.delivery-out-of-stock.hide').length === 0
                        ) {
                            $('.shipping-options-available').addClass('d-none');
                        }
                    }
                }
            } else if (
                response.product.backorder ||
                response.product.isBundle ||
                $isBundledPrduct.length
            ) {
                instoreDeliveryEligible = false;
                instoreDeliveryAvailable = false;
                $storeDetails.addClass('hide');
            } else {
                instoreDeliveryEligible = false;
                instoreDeliveryAvailable = false;
                var $inStorePickupMsg = $(
                    '.product-store-pickup-message',
                    $productContainer
                );
                if ($('input#defaultStore').length) {
                    var name = $('input#defaultStore').val()
                        ? $('input#defaultStore')
                              .val()
                              .replace(' - GameStop', '')
                        : 'Select a store';
                    $instoreDelivery.find('.store-name').text(name);
                    $instoreDelivery
                        .find('.store-unavailable-message.store-data')
                        .removeClass('hide');
                }
                $instoreDelivery.find('.store-unavailable').removeClass('hide');
                $storeDetails.addClass('hide');
                $inStorePickupMsg.find('.preorder-bydate').addClass('hide');
                $inStorePickupMsg.find('.preorder-afterdate').addClass('hide');

                // show pickup tomorrow on store pickupe label
                $instoreDelivery.find('.pick-today').addClass('hide');
                $instoreDelivery.find('.pick-tomorrow').removeClass('hide');
                $instoreDelivery.find('.store-unavailable').addClass('hide');
            }

            if (!response.product.isDeliveryAllowed) {
                if (!response.product.allowBOPS) {
                    $addToCartButton.attr('disabled', 'disabled');
                    $applePay.addClass('d-none');
                    $addToCartButton.text(
                        getButtonLabelByState('notAvailable')
                    );
                }
            }

            $digitalRedesignMessage.addClass('d-none');
            $productAdditionalMessages.removeClass('d-none');
        } else {
            homeDeliveryEligible = false;
            sameDayDeliveryEligible = false;
            instoreDeliveryEligible = false;
            homeDeliveryAvailable = true;
            sameDayDeliveryAvailable = false;
            instoreDeliveryAvailable = false;
            isDigitalProduct = true;
            // eslint-disable-next-line no-lonely-if
            if ($digitalRedesignMessage.length) {
                $digitalRedesignMessage
                    .empty()
                    .html($productAdditionalMessages.html())
                    .removeClass('d-none');
                $productAdditionalMessages.addClass('d-none');
            }
        }
    } else {
        homeDeliveryEligible = false;
        sameDayDeliveryEligible = false;
        instoreDeliveryEligible = false;
    }

    updateFulfillment(response.product.isInventoryOverriden);

    // updating Additional product 'Add to Cart' button
    var $additionalProductButton = $(
        '.cart-and-ipay-tile button.add-to-cart.variant-add-to-cart',
        $productContainer
    );
    if ($additionalProductButton.length) {
        $additionalProductButton
            .removeAttr('disabled')
            .text($additionalProductButton.data('add-text'));
    }

    if ($gettingStarted.length) {
        $gettingStarted.text($gettingStarted.data('get-started-text'));
    }

    if ($('.instore-store-text').hasClass('hide')) {
        $gettingStarted.attr('disabled', 'disabled');
    }

    var isXAAInstoreExperience = cookie.get('xaaInstoreExperience');
    var inStoreTile = $('.instore-delivery');
    var isPickupTileDisabled = $shippingOptions
        .find('.instore-delivery')
        .find('input[type=radio]')
        .attr('disabled');
    if (
        $gettingStarted &&
        isXAAInstoreExperience &&
        (inStoreTile.length === 0 ||
            isPickupTileDisabled === 'disabled' ||
            isPickupTileDisabled === 'true') &&
        $gettingStarted.length !== 0
    ) {
        $gettingStarted.attr('disabled', 'disabled');
    }

    toggleProductPrimaryDetailsDisplay();

    if (response.product.eligibleTradeInItem) {
        $('body').trigger('product:updateOnlineTradeinATC');
    }

    $('body').trigger('product:fulfillmentOptionsUpdated');
}

/**
 * updating delivery option details based on ajax response
 * @param {Object} response - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function updateMightAlsoNeedOptions(response, $productContainer) {
    var $deliveryOptionSelected = $(
        '.delivery-options-pid .delivery-option:checked'
    ).val();
    var disclaimerButtonText = $('#disclaimer-atc-button-text').val();
    var asterisk = $('<span class="add-cart-asterisk">*</span>');
    if (response.product.available && response.product.readyToOrder) {
        // Upsell both products with checkbox option
        var $optionalProduct = $('.option-to-add');
        var $bothProduct = $('.bothProds-complete-set');
        var $singleRecomm = $('.single-recommendation');
        var optionalVariantUrl = $productContainer
            .find('.option-to-add .variant-recommendation #variantURL')
            .val();
        var $productName = response.product.productName;
        if (
            optionalVariantUrl &&
            response.product.orderableRecommendations.ID !== null
        ) {
            optionalVariantUrl = utils.appendParamToURL(
                optionalVariantUrl,
                'pid',
                response.product.orderableRecommendations.ID
            );
            $.get(optionalVariantUrl, function (optionTileResponse) {
                $('.option-to-add .variantID').html(optionTileResponse);
                if ($('.option-to-add .recomm-check')) {
                    $('.master-product-name').text($productName);
                }
                if ($('#checkState').val() === 'true') {
                    $('#add-recomm-product').prop('checked', true);
                    $('.recomm-option-checkbox').addClass('selected');
                } else {
                    $('#add-recomm-product').prop('checked', false);
                    $('.recomm-option-checkbox').removeClass('selected');
                }
                if (
                    $deliveryOptionSelected !== 'home' &&
                    $('button.variant-add-to-cart').length
                ) {
                    $('.add-to-cart-disclaimer').text(disclaimerButtonText);
                    $('button.variant-add-to-cart').prepend(asterisk);
                    $('.add-to-cart-disclaimer').show();
                } else {
                    $('.add-to-cart-disclaimer').hide();
                }
            });
            $optionalProduct.show();
            $singleRecomm.hide();
        } else {
            $optionalProduct.hide();
        }

        // Upsell both products with tiles
        var variantUrl = $productContainer
            .find('.bothProds .variant-recommendation #variantURL')
            .val();
        if (
            variantUrl &&
            response.product.orderableRecommendations.ID !== null
        ) {
            var masterUrl = $productContainer
                .find('.bothProds .variant-master #variantMasterURL')
                .val();
            if (masterUrl) {
                masterUrl = utils.appendParamToURL(
                    masterUrl,
                    'pid',
                    response.product.id
                );
                $.get(masterUrl, function (masterTileResponse) {
                    $('.bothProds .parent-id').html(masterTileResponse);
                });
            }
            variantUrl = utils.appendParamToURL(
                variantUrl,
                'pid',
                response.product.orderableRecommendations.ID
            );
            var bothButtonText = $('#both-prods-atc-button-text').val();
            $.get(variantUrl, function (variantTileResponse) {
                $('.bothProds .variantID').html(variantTileResponse);
                $('.variantID .variant-add-to-cart').text(bothButtonText);
                if (
                    $deliveryOptionSelected !== 'home' &&
                    $('button.variant-add-to-cart').length
                ) {
                    $('.add-to-cart-disclaimer').text(disclaimerButtonText);
                    $('button.variant-add-to-cart').prepend(asterisk);
                    $('.variantID .add-to-cart-disclaimer').show();
                } else {
                    $('.variantID .add-to-cart-disclaimer').hide();
                }
            });
            $bothProduct.show();
            $singleRecomm.hide();
        } else {
            $bothProduct.hide();
        }

        // Upsell single recomm products
        var singleVariantUrl = $productContainer
            .find('.single-recommendation .variant-recommendation #variantURL')
            .val();
        if (
            singleVariantUrl &&
            response.product.orderableRecommendations.ID !== null &&
            $('.bothProds').length === 0 &&
            $('.option-to-add').length === 0
        ) {
            singleVariantUrl = utils.appendParamToURL(
                singleVariantUrl,
                'pid',
                response.product.orderableRecommendations.ID
            );
            $.get(singleVariantUrl, function (tileResponse) {
                $('.single-recommendation .variantID').html(tileResponse);
                if (
                    $deliveryOptionSelected !== 'home' &&
                    $('button.variant-add-to-cart').length
                ) {
                    $('.add-to-cart-disclaimer').text(disclaimerButtonText);
                    $('button.variant-add-to-cart').prepend(asterisk);
                    $('.add-to-cart-disclaimer').show();
                } else {
                    $('.add-to-cart-disclaimer').hide();
                }
            });
            $singleRecomm.show();
        } else {
            $singleRecomm.hide();
        }
    } else {
        // Upsell single recomm products
        var $optionalProductOpt = $('.option-to-add');
        var $bothProductOpt = $('.bothProds-complete-set');
        var $singleRecommOpt = $('.single-recommendation');
        var singleVarUrl = $productContainer
            .find('.single-recommendation .variant-recommendation #variantURL')
            .val();

        if (
            singleVarUrl &&
            response.product.orderableRecommendations.ID !== null
        ) {
            $bothProductOpt.hide();
            $optionalProductOpt.hide();
            singleVarUrl = utils.appendParamToURL(
                singleVarUrl,
                'pid',
                response.product.orderableRecommendations.ID
            );
            $.get(singleVarUrl, function (tileResponse) {
                $('.single-recommendation .variantID').html(tileResponse);
                if (
                    $deliveryOptionSelected !== 'home' &&
                    $('button.variant-add-to-cart').length
                ) {
                    $('.add-to-cart-disclaimer').text(disclaimerButtonText);
                    $('button.variant-add-to-cart').prepend(asterisk);
                    $('.add-to-cart-disclaimer').show();
                } else {
                    $('.add-to-cart-disclaimer').hide();
                }
            });
            $singleRecommOpt.show();
            $('.single-recommendation .complete-the-set').show();
        } else {
            $singleRecommOpt.hide();
            $bothProductOpt.hide();
            $optionalProductOpt.hide();
        }
    }
}

/**
 * get OrderableConditionAttributes
 * @param {Object} product - response product from Ajax call
 * @return {Object[]}
 */
function getOrderableConditionAttributes(product) {
    const conditions = [];
    product.variationAttributes.forEach(function (attr) {
        if (attr.id === 'condition') {
            attr.values.forEach((value) => {
                if (value.orderable) {
                    conditions.push(value);
                }
            });
        }
    });

    return conditions;
}

/**
 * get Pro Points Message
 * @param {Object} response - response from Ajax call
 */
function getProPointsMessage(response) {
    var customerGroups = getCookie($('#customergroupcookie').val());
    var showProPointsOnPDPResult = $('#showProPointsOnPDPResult').val();
    var isProPromotionEnabled = $('#isProPromotionEnabled').val();
    var isProUser = false;
    if (
        customerGroups &&
        (customerGroups.includes('PUR-Pro') ||
            customerGroups.includes('PUR-Elite'))
    ) {
        isProUser = true;
    }

    var $propointUpsellmessage = $('.propoints-upsell-message');

    if (showProPointsOnPDPResult === 'true') {
        if (isProUser) {
            if (!response.product.seePriceInCart && response.product.proDayPoints) {
                if (
                    isProPromotionEnabled === 'true' &&
                    response.resources.pro_promotions_message
                ) {
                    $propointUpsellmessage
                        .empty()
                        .append(
                            '<span class="promembership-points-value pro-promotion-message">' +
                                response.resources.pro_promotions_message.replace(
                                    '<points>',
                                    response.product.proDayPoints.toLocaleString()
                                ) +
                                '</span>'
                        );
                    $propointUpsellmessage.append(
                        '<span><a class="learnmore" href="" data-toggle="modal" data-target="#proPromotionModal">' +
                            response.resources.pro_promotions_details +
                            '</a></span>'
                    );
                } else {
                    $propointUpsellmessage
                        .empty()
                        .append(
                            '<span class="promembership-points-value">' +
                                response.resources.pro_points +
                                ' ' +
                                response.product.proDayPoints.toLocaleString() +
                                ' ' +
                                response.resources.propoints +
                                '</span>'
                        );
                }
            }
        } else {
            // Default messaging
            let proDiscountMessage = 'Get $65 in savings';

            const conditions = getOrderableConditionAttributes(
                response.product
            );
            const preOwnedConditions = conditions.filter(
                (condition) =>
                    condition.displayValue
                        .toLowerCase()
                        .includes('refurbished') ||
                    condition.displayValue.toLowerCase().includes('pre-owned')
            );

            // If selected product has no pro discount, but preowned variants available
            if (preOwnedConditions.length) {
                proDiscountMessage = 'Save 5% on PreOwned + $65 in savings';
            }

            // Preowned variant is selected
            if (
                response.product.price.salePriceIncludingPro ||
                response.product.price.seePriceInCartPro
            ) {
                if (
                    response.product.preowned ||
                    response.product.productCondition
                        ?.toLowerCase()
                        ?.includes('refurbished')
                ) {
                    proDiscountMessage = 'Save 5% now + $65 in savings';
                }
            }

            $propointUpsellmessage.empty()
                .append(`<a class="pro-upgrade-anchor" href="" data-toggle="modal" data-target="#playerUpgradeModal"><div class="pro-upgrade-wrapper"><p><span class="pro-color">${proDiscountMessage}</span> when you become a GameStop Pro - <span class="upgrade-learn-more">See benefits & join now</span></p><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.31249 14.25C7.20878 14.2546 7.10524 14.2377 7.00841 14.2002C6.91159 14.1628 6.82359 14.1057 6.74999 14.0325C6.67969 13.9627 6.62389 13.8798 6.58582 13.7884C6.54774 13.697 6.52814 13.599 6.52814 13.5C6.52814 13.4009 6.54774 13.3029 6.58582 13.2115C6.62389 13.1201 6.67969 13.0372 6.74999 12.9675L10.755 8.99996L6.74999 5.03246C6.60876 4.89123 6.52942 4.69968 6.52942 4.49996C6.52942 4.40106 6.5489 4.30314 6.58674 4.21177C6.62459 4.1204 6.68006 4.03738 6.74999 3.96746C6.81991 3.89753 6.90293 3.84206 6.9943 3.80421C7.08567 3.76637 7.18359 3.74689 7.28249 3.74689C7.48221 3.74689 7.67376 3.82623 7.81499 3.96746L12.315 8.46746C12.3853 8.53718 12.4411 8.62013 12.4792 8.71152C12.5172 8.80292 12.5368 8.90095 12.5368 8.99996C12.5368 9.09896 12.5172 9.19699 12.4792 9.28839C12.4411 9.37978 12.3853 9.46273 12.315 9.53246L7.81499 14.0325C7.68088 14.1657 7.50141 14.2434 7.31249 14.25Z" fill="#404040"/>
            </svg></div></a>`);
        }
    } else {
        $propointUpsellmessage.empty();
        $propointUpsellmessage.addClass('d-none');
    }
}

/**
 * Add releaseDate into price update location
 * @param {string} releaseDate Release date
 */
function addReleaseDate(releaseDate) {
    var $priceUpdate = $('.price-update');
    var $seePriceDetails = $('.selling-price-details', $priceUpdate);
    var $sellingPriceRedesign = $('.selling-price-redesign', $priceUpdate);
    $seePriceDetails.removeClass('no-release-date');
    $sellingPriceRedesign.removeClass('no-release-date');
    $priceUpdate = $('.release-date', $seePriceDetails);

    if (!$('.pdp-release-date', $priceUpdate).length) {
        $priceUpdate.append(
            '<span class="pdp-release-date font-bold">' +
                releaseDate +
                '</span>'
        );
        $priceUpdate.find('.price:first').addClass('d-inline-block pr-3');
    }
}

/**
 * Reset certified refurbished content display
 */
function resetCertifiedRefurbishedContent() {
    var $productPreownedSection = $('.product-refurbished-section');
    var $certifiedPreownedSection = $('.certified-product-refurbished-section');
    $certifiedPreownedSection.addClass('d-none');
    $productPreownedSection.remove('d-none');
}

/**
 * Check if product is of condition certified refurbished
 * @param {Object} response variation call response
 * @returns {boolean} isCertifiedRefurbished
 */
function isProductCertifiedRefurbished(response) {
    try {
        var {
            selectedVariationAttributes,
            productCondition,
            isCertifiedRefurbished
        } = response.product;
        var selectedVariationAttr =
            selectedVariationAttributes &&
            selectedVariationAttributes.map((variation) => variation.id)[0];
        var isConditionRefurbished = false;
        var isConditionCertifiedRefurbished = false;

        if (selectedVariationAttr) {
            isConditionRefurbished =
                selectedVariationAttr
                    .toLocaleLowerCase()
                    .indexOf('refurbished') !== -1;
            isConditionCertifiedRefurbished =
                selectedVariationAttr
                    .toLocaleLowerCase()
                    .indexOf('certified-refurbished') !== -1;
        }

        if (productCondition) {
            isConditionRefurbished =
                productCondition &&
                productCondition.toLocaleLowerCase().indexOf('refurbished') !==
                    -1;
            isConditionCertifiedRefurbished =
                productCondition &&
                productCondition
                    .toLocaleLowerCase()
                    .indexOf('certified-refurbished') !== -1;
        }

        return (
            (isCertifiedRefurbished && isConditionRefurbished) ||
            isConditionCertifiedRefurbished
        );
    } catch (err) {
        return false;
    }
}

/**
 * Get ship state analytics
 * @param {Object} response response
 * @returns {String} eventLabel
 */
function getShipStateAnalytics(response) {
    var eventLabel = '';
    if (
        response.gtmDetail &&
        !isDigitalProduct &&
        $('.home-delivery.fulfillment-tile').not('.d-none').length
    ) {
        if (
            $('.option-label .orderOption-label-preorder').not('.d-none').length
        ) {
            eventLabel = 'Pre-Order';
        } else if (
            $('.option-card-message .dimension32-analytics').not('.hide').length
        ) {
            eventLabel = $('.option-card-message .dimension32-analytics')
                .not('.hide')
                .text();
        } else {
            eventLabel = 'Not Available';
        }
        return eventLabel;
    }
    return eventLabel;
}

/**
 * Get BOPS state analytics
 * @param {Object} response response
 * @returns {String} dayDetail and stockDetail
 */
function getBOPSStateAnalytics(response) {
    var dayDetail = '';
    var stockDetail;
    if (
        response.gtmDetail &&
        !isDigitalProduct &&
        $('.instore-delivery.fulfillment-tile').not('.d-none').length
    ) {
        var dimension31Analytics = $(
            '.option-label .dimension31-analytics'
        ).not('.hide');
        if (dimension31Analytics.length) {
            if (
                $('.product-store-pickup-message .same-day').not('.hide').length
            ) {
                dayDetail = dimension31Analytics.text() + ' EOD';
            } else {
                dayDetail = dimension31Analytics.text();
            }
        }
        if ($('.product-store-message').text()) {
            stockDetail = 'Low Stock';
        } else if ($('.outOfStockInstore').not('.hide').length) {
            stockDetail = 'OOS';
        } else if ($('.inStockInstore').not('.hide').length) {
            stockDetail = 'In Stock';
        } else {
            stockDetail = 'Unknown';
        }
        return dayDetail + '/' + stockDetail;
    }
    return dayDetail;
}

/**
 * Get sdd state analytics
 * @param {Object} response response
 * @returns {String} dayDetail and stockDetail
 */
function getSddStateAnalytics(response) {
    var dayDetail = '';
    var stockDetail;
    if (
        response.gtmDetail &&
        !isDigitalProduct &&
        $('.same-day-delivery.js-same-day-delivery.fulfillment-tile').not(
            '.d-none'
        ).length
    ) {
        var dimension30Analytics = $(
            '.option-label .dimension30-analytics'
        ).not('.hide');
        var countDownTimer = $(
            '.product-delivery-message .same-day .countdown-timer'
        );
        if (dimension30Analytics.length) {
            if (
                $('.product-delivery-message .same-day').not('.hide').length &&
                ($('.product-delivery-message .label-get-in').not('.d-none')
                    .length ||
                    (countDownTimer.length && countDownTimer.text()))
            ) {
                dayDetail =
                    dimension30Analytics.text().replace('Deliver ', '') +
                    ' EOD';
            } else {
                dayDetail = dimension30Analytics.text().replace('Deliver ', '');
            }
        }
        var productStoreMessage = $(
            '.selected-address-details .product-store-message'
        );
        if (
            productStoreMessage.not('.hide').length &&
            productStoreMessage.text()
        ) {
            if (countDownTimer.length && countDownTimer.text()) {
                stockDetail =
                    productStoreMessage.text() +
                    '/' +
                    countDownTimer.text().replace(' Order in ', '');
            } else {
                stockDetail = productStoreMessage.text();
            }
        } else if ($('.option-card-message .outOfStock').not('.hide').length) {
            stockDetail = 'OOS';
        } else if ($('.option-card-message .inStock').not('.hide').length) {
            stockDetail = 'In Stock';
        } else {
            stockDetail = 'Store Unknown';
        }
        return dayDetail + '/' + stockDetail;
    }
    return dayDetail;
}

/**
 * Update PreOwned Guarantee Block
 * @param {Object} response - response from Ajax call
 */
function toggleCertifiedRefurbishedContent(response) {
    var $productPreownedSection = $('.preowned-guarantee-section');
    var $certifiedPreownedSection = $('.certified-product-refurbished-section');
    var isCertifiedRefurbished = isProductCertifiedRefurbished(response);
    var isConditionPreOwned =
        response.product.productCondition === 'Refurbished' ||
        response.product.preowned;

    // show certified refurbished content if flag is true and condition is refurbished
    if (isCertifiedRefurbished) {
        $certifiedPreownedSection.removeClass('d-none');
        $productPreownedSection.addClass('d-none');
    } else if (isConditionPreOwned) {
        $productPreownedSection.removeClass('d-none');
        $certifiedPreownedSection.addClass('d-none');
    } else {
        $certifiedPreownedSection.addClass('d-none');
        $productPreownedSection.addClass('d-none');
    }
}

/**
 * get Pro Member Free Shipping Message
 * @param {jQuery} $productContainer - DOM element for current product
 */
var getProMemberFreeShippingMessage = function () {
    var customerGroups = getCookie($('#customergroupcookie').val());
    var isProUser = false;
    if (
        customerGroups &&
        (customerGroups.includes('PUR-Pro') ||
         customerGroups.includes('PUR-Elite'))
    ) {
        isProUser = true;
    }
    var isProMemFreeShipping =
        isProUser && $('#isProMemberFreeShipping').val() === 'true';
    var msg = $('div.option-card-title span.option-label-msg-preorder').data(
        isProMemFreeShipping ? 'homedelivery' : 'homedelivery-pre-order'
    );
    $('div.option-card-title span.option-label-msg-preorder').html(msg);
    var msg2 = $('div.option-card-title span.orderOption-label').data(
        isProMemFreeShipping ? 'onallorders' : 'order-message'
    );
    $('div.option-card-title span.orderOption-label').html(msg2);
    var msg3 = $('div.option-card-title span.orderOption-label-preorder').data(
        isProMemFreeShipping ? 'onallorders-preorder' : 'order-message-preorder'
    );
    $('div.option-card-title span.orderOption-label-preorder').html(msg3);
};

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {boolean} isOptionClicked - Warranty recommendation clicked
 * @param {boolean} isFastShippingNotAllowed - is fast shipping not allowed
 * @param {any} type type of selection variation or sibling
 */
function handleVariantResponse(
    response,
    $productContainer,
    isOptionClicked,
    isFastShippingNotAllowed,
    type
) {
    var customerGroups = getCookie($('#customergroupcookie').val());
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    var $redesignPriceinCart = $('.map-pricing-redesign');
    var $isBundledPrduct = $('#isBundledProduct');
    var isBundleProductWarrantyOptionSelected =
        $isBundledPrduct.length && isOptionClicked;
    var isProUser = false;
    if (
        customerGroups &&
        (customerGroups.includes('PUR-Pro') ||
            customerGroups.includes('PUR-Elite'))
    ) {
        isProUser = true;
    }

    resetPrices(response);
    getProPointsMessage(response); // for badge

    if (
        isBuyBoxOnPDPEnabled === 'true' &&
        response.product &&
        response.product.allAttributesCombos
    ) {
        // update data to reflect new response
        $('[data-attr-combos]').data(
            'attr-combos',
            response.product.allAttributesCombos
        );
    }

    isProductInStock = response.product ? response.product.available : false;


    // do not handle response if the warranty option selected for bundle products, only update pro points
    if (isBundleProductWarrantyOptionSelected) {
        return;
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        var $priceUpdate = $('.price-update');
        var mapPricingHTML = '';
        if (response.product.seePriceInCart && response.product.hidePricePDP) {
            mapPricingHTML +=
                '<span class="price-update"><span class="price"><span class="price"><span class="selling-price-redesign"><span class="actual-price">' +
                response.resources.info_seeincart +
                '</span></span></span></span></span>';
            if (
                response.product.price.salePriceExcludingPro !== null &&
                response.product.price.salePriceIncludingPro !== null &&
                response.product.price.salePriceExcludingPro.value >
                response.product.price.salePriceIncludingPro.value
            ) {
                mapPricingHTML +=
                '<div class="pro-day-pricing-2022 copy show pro-pricing">' +
                response.resources.info_seeincartpro +
                '</div>';
            }
            $redesignPriceinCart.html(mapPricingHTML);
            $priceSelector.html(
                '<span class="sales"><span class="value">' +
                response.resources.info_seeincart +
                '</span></span>'
            );
        } else if (
            !(
                $productContainer.hasClass('product-detail-redesign') &&
                isOptionClicked
            )
        ) {
            $redesignPriceinCart.empty();
            $priceSelector.replaceWith(response.product.price.html);
            const price = response.product.price.min
                ? response.product.price.min.sales.formatted
                : response.product.price.sales.formatted;
            $('#pdp-open-flexpay-modal').attr('data-product-price', price);
            $priceUpdate.html(response.product.price.html);
            if (response.product.seePriceInCart && response.product.hideProPricePDP &&
                (response.product.price.salePriceExcludingPro !== null &&
                response.product.price.salePriceIncludingPro !== null &&
                response.product.price.salePriceExcludingPro.value >
                response.product.price.salePriceIncludingPro.value)
            ) {
                mapPricingHTML =
                '<div class="pro-day-pricing-2022 copy show pro-pricing">' +
                response.resources.info_seeincartpro +
                '</div>';
                $('.primary-details-row .price-update #pro-price-span').html(mapPricingHTML);
                $('.actual-price.actual-price-strikethroughable-span.see-price-in-cart.strike-through').removeClass('strike-through');
            }
            $priceSelector.html(
                '<span class="sales"><span class="value">' +
                response.resources.info_seeincart +
                '</span></span>'
            );
        }
    }

    if (response.product.variationAttributes) {
        updateAttrs(
            response.product.variationAttributes,
            $productContainer,
            response.resources,
            response.savingViolatorPercentage,
            isOptionClicked,
            type
        );
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer
                .parent('.bonus-product-item')
                .data('pid', response.product.id);
            $productContainer
                .parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
            $productContainer
                .parent('.bonus-product-item')
                .data('is-preorder', response.product.preorder);
        }
        if (response.product.releaseDate) {
            addReleaseDate(response.product.releaseDate);
        }
    }

    if (response.product.bvProductID) {
        $('.pdp_rating_summary').attr(
            'data-bv-productid',
            response.product.bvProductID
        );
    }

    if (isBuyBoxOnPDPEnabled === 'true') {
        setBuyableAndUrlForSelection();
        setAttributeLabelsToSelection();
    } else if (response.product.allVariantsStoreAvailability.length) {
        // update color swatch that is not availble at stores using store_ATP attribute
        let selectedVarientCondition =
            response.product.selectedVariationAttributes[0];
        if (
            selectedVarientCondition &&
            selectedVarientCondition.attributeId === 'condition'
        ) {
            let colorAttributes = response.product.variationAttributes.filter(
                function (attr) {
                    return attr.attributeId === 'color';
                }
            );
            if (colorAttributes.length) {
                colorAttributes[0].values.forEach((obj) => {
                    let $colorSwatch = $(
                        'span[data-attr-value=' + obj.id + ']'
                    );
                    if ($colorSwatch.length) {
                        if (obj.orderable) {
                            if ($colorSwatch.hasClass('not-orderable')) {
                                $colorSwatch
                                    .addClass('orderable')
                                    .removeClass('not-orderable');
                            }
                        } else if ($colorSwatch.hasClass('orderable')) {
                            $colorSwatch
                                .addClass('not-orderable')
                                .addClass('unselectable')
                                .removeClass('orderable');
                        }
                    }
                    if (isBuyBoxOnPDPEnabled === 'true') {
                        $colorSwatch
                            .removeClass(
                                'selectable unselectable orderable not-orderable'
                            )
                            .addClass('is-selectable');
                    }
                });
            }
        }
    }

    // Update Points
    var $earnedPointsSelector = $('.points-earned-value');
    var $atcMessageSelector = $('.post-atc-proday-message');
    var $signupLinkSelector = $('.signup-checkbox-container');
    var $pointsEarnedMessage = $('.points-earned-message');
    var $nonMemberProPointsSelector = $('.nonmember-pro-points');
    var $nonMemberProDaylabel = $('.nonmember-proday-label-signup');
    var $nonMemberPointslabel = $('.nonmember-label-signup');
    var $promotionsRedesignContainer = $('.promotions-redesign-container');
    var $promotionsRedesign = $('.promotions-redesign');

    if ($nonMemberProPointsSelector.length) {
        $nonMemberProPointsSelector.html(response.product.proDayPoints);
    }

    var purProMagazineFormat = $('#proMemberMagazineFormat').val();
    if (purProMagazineFormat) {
        var $powerupDetailsMagazineFormat = $(
            '#powerupDetailsModal .membership-price'
        ).find('.' + purProMagazineFormat.toLowerCase());
        $powerupDetailsMagazineFormat.removeClass('d-none');
    }

    $pointsEarnedMessage.removeClass('d-none');
    $earnedPointsSelector.html(response.product.proDayPoints);
    $atcMessageSelector.removeClass('d-none');
    $signupLinkSelector.removeClass('d-none');

    if (
        response.product.proDayPrice &&
        response.product.proDayPrice.appliedPrmotion
    ) {
        $nonMemberProDaylabel.removeClass('d-none');
        $nonMemberPointslabel.addClass('d-none');
    } else {
        $nonMemberProDaylabel.addClass('d-none');
        $nonMemberPointslabel.removeClass('d-none');
    }

    // Update PreOwned Guarantee Block
    toggleCertifiedRefurbishedContent(response);

    // Update promotions
    var allPromotions = [];

    if (response.product.promotions) {
        allPromotions = allPromotions.concat(response.product.promotions);
    }

    if ($isBundledPrduct.length && typeof isOptionClicked === 'undefined') {
        // surpassing the promotions if it is a bundled product
        $('.promotions').empty().html(getPromotionsHtml(allPromotions));
        var bundlePromotionData = getPromotionsRedesignHtml(
            allPromotions,
            response.resources,
            response.minShowPromotionLength
        );
        if (bundlePromotionData) {
            $promotionsRedesignContainer.show();
            $promotionsRedesign.empty().html(bundlePromotionData);
        } else {
            $promotionsRedesignContainer.hide();
        }
    } else if (!$isBundledPrduct.length) {
        $('.promotions').empty().html(getPromotionsHtml(allPromotions));
        var promotionData = getPromotionsRedesignHtml(
            allPromotions,
            response.resources,
            response.minShowPromotionLength
        );
        if (promotionData) {
            $promotionsRedesignContainer.show();
            $promotionsRedesign.empty().html(promotionData);
        } else {
            $promotionsRedesignContainer.hide();
        }
    }

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        // 02/24/2023 removed updating the pdp ATC button .js-add-to-cart... obscuring the actions on ATC doesn't help
        // calls updateAddToCart from cartridges/app_storefront_base/cartridge/client/default/js/product/detail.js
        // These class don't seem to exist. can rip out.
        $('button.add-to-cart-global, button.update-cart-product-global')
            .trigger('product:updateAddToCart', {
                product: response.product,
                $productContainer: $productContainer
            })
            .trigger('product:statusUpdate', response.product);
    }

    $('button.add-to-cart', response.$productContainer).attr(
        'disabled',
        !response.product.readyToOrder || !response.product.available
    );

    // Update attributes
    $productContainer
        .find('.main-attributes')
        .empty()
        .html(base.getAttributesHtml(response.product.attributes));

    // Update PowerUpRewards attributes
    if (response.product.isPURProduct) {
        updatePowerUpRewardsData(response, $productContainer);
    }

    // update release date
    if (response.product.releaseDate) {
        $productContainer
            .find('.pdp-release-date')
            .empty()
            .html(response.product.releaseDate)
            .removeClass('d-none');
    } else if (response.product.releaseDate === null) {
        $productContainer.find('.pdp-release-date').empty().addClass('d-none');
    }

    // update street date guarantee
    if (
        response.product.streetDateGuarantee &&
        response.product.streetDateGuarantee.showStreetDateGuarantee &&
        response.product.streetDateGuarantee.html
    ) {
        $productContainer
            .find('.product-street-date-guarantee-section')
            .empty()
            .html(response.product.streetDateGuarantee.html)
            .removeClass('d-none');
    } else {
        $productContainer
            .find('.product-street-date-guarantee-section')
            .empty()
            .addClass('d-none');
    }

    getProMemberFreeShippingMessage();

    updateDeliveryOptions(
        response,
        $productContainer,
        isOptionClicked,
        isFastShippingNotAllowed
    );

    var selectedEditionPosition = parseInt(
        $('#selectedEditionPosition').attr('value'),
        10
    );
    var editionSwatchCountThreshold = parseInt(
        $('#editionSwatchCountThreshold').attr('value'),
        10
    );
    var editionCount = parseInt($('#editionCount').attr('value'), 10);
    var editionexpanded = new URL(window.location).searchParams.get(
        'editionexpanded'
    );

    if (
        !editionexpanded &&
        selectedEditionPosition > editionSwatchCountThreshold &&
        editionCount > editionSwatchCountThreshold + 1
    ) {
        $('.edition-attribute span.selected')
            .parent('a')
            .prependTo('.edition-attribute.swatch-attribute')
            .removeClass('d-sm-none');
        if (editionCount > editionSwatchCountThreshold + 1) {
            editionSwatchCountThreshold++;
            $('.edition-attribute.swatch-attribute')
                .find(
                    'a.edition-label:nth-child(' +
                        editionSwatchCountThreshold +
                        ')'
                )
                .addClass('d-sm-none');
        }
    }

    // update you might also need options
    updateMightAlsoNeedOptions(response, $productContainer);
    window.selectedVariantId = response.product.selectedVariantId;
    if ($('#productTypeSeo').val() !== 'master') {
        document.title = response.pageTitle;
    }
    $('.product-name').html(response.product.productName);

    var actualPriceElements = $('.actual-price-strikethroughable-span');
    actualPriceElements.each(function () {
        $(this).removeClass('has-pro-pricing');
    });

    // hide the selling price details if the list price and sale price excluding pro is the same
    if (isProUser) {
        if (
            (!response.product.seePriceInCart) &&
            response.product.price.salePriceExcludingPro !== null &&
            response.product.price.salePriceIncludingPro !== null &&
            response.product.price.salePriceExcludingPro.value >
            response.product.price.salePriceIncludingPro.value
        ) {
            $('.selling-price-redesign .actual-price').addClass(
                'strike-through'
            );
        }

        if (
            response.product.price.salePriceExcludingPro &&
            response.product.price.list &&
            response.product.price.salePriceExcludingPro.value !== null &&
            response.product.price.salePriceExcludingPro.value ===
                response.product.price.list.value
        ) {
            $('.pro-day-pricing-2022').addClass('pro-day-pricing-2022--active');
            $(
                '.buy-box-fixed .pro-day-pricing-2022, #primary-details #pro-saving-indicator'
            ).show();
        }
    }
}

/**
 *  Update Trade link on click of variants
 */
function updateTradeLink() {
    if (
        $('.main-wishlist .wishlist-and-trade-section-redesign .trade-value')
            .length
    ) {
        var $mainTrade = $(
            '.main-wishlist .wishlist-and-trade-section-redesign .trade-value'
        ).clone();
        var $placeTrade = $(
            '.desktop-trade .wishlist-and-trade-section-redesign .wishlist-and-trade'
        );
        $placeTrade.html($mainTrade);
        var $placeWishlistPopup = $(
            '.desktop-trade .wishlist-and-trade-section-redesign .wishlist-and-trade .trade-value'
        );
        var $mainWishlistPopup = $(
            '.main-wishlist .wishlist-and-trade-section-redesign .library-modal'
        ).clone();
        $mainWishlistPopup.insertBefore($placeWishlistPopup);
    }
}

/**
 * Gets the estimated delivery time display message. We take gtsCookie and zip code to get the estimated date message.
 * @param {jQuery} $productContainer - DOM element for current product
 */
var getDeliveryMessage = function ($productContainer) {
    var zipcode = getCookie('zc1');
    var gtsPrefValue = $('#gtsCookie').val();
    var gtsCookie;
    if (gtsPrefValue !== 'null') {
        gtsCookie = getCookie(gtsPrefValue);
        if (gtsCookie === null) {
            gtsCookie = 'true';
        }
    }
    var url = $('#estDateRangeMsgUrl', $productContainer).val();
    url = utils.appendParamToURL(url, 'zip', zipcode);
    url = utils.appendParamToURL(url, 'gts', gtsCookie);

    $.ajax({
        url: url,
        method: 'GET',
        success: function (response) {
            var estimatedDateMessageArray = '';
            var $shippingOptions = $(
                '.shipping-options-available',
                $productContainer
            );
            var $homeDelivery = $shippingOptions.find('.home-delivery');
            var $expectedDeliveryMessage = $(
                '.option-card-message',
                $homeDelivery
            );
            if (response.estimatedDateRangeMessage) {
                estimatedDateMessageArray = response.estimatedDateRangeMessage;
            }
            if (estimatedDateMessageArray.length) {
                $expectedDeliveryMessage.removeClass('hide');
                $('.d-block', $homeDelivery).removeClass('hide');
                $('.delivery-message', $homeDelivery).html(
                    estimatedDateMessageArray[0]
                );
                $expectedDeliveryMessage
                    .find('span')
                    .not('.delivery-unavailable')
                    .removeClass('hide');
                $homeDelivery.find('.delivery-out-of-stock').addClass('hide');
            }
        }
    });
};

/**
 * Return CTA states as experienceType given a data from variation url call
 * @param {*} data returned from selected variantion request
 * @returns string
 */
function gaExperienceType(data) {
    let experienceType = '';
    if (
        data.product.available &&
        data.product.readyToOrder &&
        data.product.isDeliveryAllowed
    ) {
        experienceType = 'Available';
    } else {
        experienceType = 'OOS Notify Off/No Sku';
    }

    if (
        data.sameDayDelivery !== undefined &&
        data.sameDayDelivery.isSDDEnable &&
        Object.hasOwnProperty.call(data.product, 'isProductSDDEligible') &&
        data.product.isProductSDDEligible &&
        !data.product.backorder &&
        !data.product.isBundle &&
        data.sameDayDelivery.actionUrl
    ) {
        let sddUrl = utils.appendParamToURL(
            data.sameDayDelivery.actionUrl,
            'pid',
            data.product.id
        );
        getSDDResponse(sddUrl);
        if (verifyAddress) {
            experienceType = 'Verify Address';
        }

        if (isStoreClosedForSameDayDeliver) {
            experienceType = 'SDD Tomorrow';
        } else {
            experienceType = 'SDD Today';
        }
    }

    if (data.product.preorder) {
        experienceType = 'Pre-Order';
    }

    if (data.product.allowBOPS) {
        if (experienceType) {
            experienceType = 'BOPS/' + experienceType;
        }
    }

    if (data.product.isDigitalProduct) {
        experienceType = 'Available';
    }

    if (data.product.seePriceInCart) {
        experienceType = 'MAPS';
    }

    return experienceType;
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {boolean} isOptionClicked - Warranty recommendation clicked
 * @param {Object} trackingData - attribute tracking data
 * @param {string} type - type of attribute selected
 * @param {function} cb - callback for attribute select
 */
function attributeSelect(
    selectedValueUrl,
    $productContainer,
    isOptionClicked,
    trackingData,
    type,
    cb
) {
    // prevent mulitple attribute select clicks
    if (isProcessRunning) return;

    var isFastShippingNotAllowed =
        selectedValueUrl.indexOf('_condition=Pre-Owned') > -1 ||
        selectedValueUrl.indexOf('_condition=Refurbished') > -1 ||
        selectedValueUrl.indexOf('_condition=Digital') > -1 ||
        $('#isFastShipNotAllowed').val() === 'true';

    if (
        $('#readDeliveryMsgFrmProdVariation').val() === 'false' &&
        !isFastShippingNotAllowed &&
        $('#isProtectedItem').val() === 'false' &&
        $('#excludeGeoFastShip').val() === 'false'
    ) {
        getDeliveryMessage($productContainer);
    }

    if (selectedValueUrl) {
        var url = selectedValueUrl;

        // add edit card UUID
        var uuid = $productContainer.find('.update-cart-url').data('uuid');
        if (uuid) {
            url = utils.appendParamToURL(url, 'uuid', uuid);
        }

        // reset the badge and content block for certified refurbished
        resetCertifiedRefurbishedContent();

        $('body').trigger('product:beforeAttributeSelect', {
            url: url,
            container: $productContainer,
            optionElement: isOptionClicked
        });

        var rtQueryStringValue = $('#rtquerystring').val();
        url = utils.appendParamToURL(url, 'rt', rtQueryStringValue);

        // set process to true before ajax to prevent multiple calls
        isProcessRunning = true;

        var $mainProductSection = $('#primary-details');
        $mainProductSection.spinner().start();

        $.ajax({
            url: url,
            method: 'GET',
            success: function (data) {
                let experienceType = gaExperienceType(data);
                var isCertifiedRefurbished =
                    isProductCertifiedRefurbished(data);
                var productViewedTracking = {
                    product: [data.gtmData],
                    isCertifiedRefurbished
                };

                // set process as done when ajax call is complete
                isProcessRunning = false;

                handleVariantResponse(
                    data,
                    $productContainer,
                    isOptionClicked,
                    isFastShippingNotAllowed,
                    type
                );

                // Update bops promotion
                $('.cart-bops-promo-section').html(data.product.bopsPromoCopy);

                updateOptions(
                    data.product.options,
                    data.product.optionsHtml,
                    $productContainer
                );
                base.updateQuantities(
                    data.product.quantities,
                    $productContainer
                );

                // track variant change when ever a change has been triggered
                $('body').trigger('product:trackVariantChange', trackingData);

                // dont call product:viewed for option click and product tiles
                if (
                    data &&
                    !isOptionClicked &&
                    data.gtmData &&
                    !$productContainer.hasClass('product-tile')
                ) {
                    $('body').trigger('product:viewed', productViewedTracking);
                }
                var shipStateAnalytics = getShipStateAnalytics(data);
                var bopsStateAnalytics = getBOPSStateAnalytics(data);
                var modifiedData = data;
                modifiedData.gtmDetail.dimension31 = bopsStateAnalytics;
                modifiedData.gtmDetail.dimension32 = shipStateAnalytics;
                setTimeout(function () {
                    var sddStateAnalytics = getSddStateAnalytics(data);
                    modifiedData.gtmDetail.dimension30 = sddStateAnalytics;
                    $('body').trigger('product:afterAttributeSelect', {
                        data: modifiedData,
                        container: $productContainer,
                        type,
                        isOptionClicked,
                        experienceType
                    });
                }, 200);

                if (typeof cb === 'function') cb();

                updateTradeLink();
                $mainProductSection.spinner().stop();
            },
            error: function () {
                $mainProductSection.spinner().stop();
                isProcessRunning = false;
            }
        });
    }
}

/**
 * get and update selected sibling attributes if needed
 * @param {Object} url - current url
 * @param {boolean} seeSearchParams - boolean which tells us to check search params from the url
 * @return {Object} - selected values, url and java
 */
function getAndUpdateSelectedSiblingAttributes(
    url,
    seeSearchParams,
    shouldNotSetQueryParam
) {
    let currentSelectedValues = {};
    let data = {
        validProduct: true
    };
    let $siblingAttributes =
        isBuyBoxOnPDPEnabled === 'true'
            ? $('.sibling-attributes-redesign .sibling-attribute')
            : $('.sibling-attributes .sibling-attribute');

    $siblingAttributes.each(function () {
        let siblingValue = $(this).data('sibling-value');
        let searchValue =
            seeSearchParams && url ? url.searchParams.get(siblingValue) : null;
        if ($(this).find('select.select-sibling-attribute').length) {
            if (
                seeSearchParams &&
                searchValue &&
                searchValue !==
                    $(this)
                        .find('select.select-sibling-attribute [selected]')
                        .data('attr-value')
            ) {
                data.validProduct = false;
                $(this)
                    .find('select.select-sibling-attribute [selected]')
                    .removeAttr('selected');
                $(this)
                    .find(
                        'select.select-sibling-attribute [data-attr-value=' +
                            searchValue +
                            ']'
                    )
                    .attr('selected', 'selected');
            }
            currentSelectedValues[siblingValue] = $(this)
                .find('select.select-sibling-attribute [selected]')
                .data('attr-value');
        } else {
            if (
                seeSearchParams &&
                searchValue &&
                searchValue !== $(this).find('li[selected]').data('attrValue')
            ) {
                data.validProduct = false;
                $(this).find('li[selected]').removeAttr('selected');
                $(this)
                    .find('li[data-attr-value=' + searchValue + ']')
                    .attr('selected', 'selected');
            }
            currentSelectedValues[siblingValue] = $(this)
                .find('li[selected]')
                .data('attrValue');
        }
        if (url && !shouldNotSetQueryParam) {
            url.searchParams.set(
                siblingValue,
                currentSelectedValues[siblingValue]
            );
        }
    });
    return { currentSelectedValues, data };
}

/**
 * handle attribute selection during page load and attribute click
 * @return {Object} - Product options and their selected values
 */
function handleSiblingAttributes(shouldNotSetQueryParam = false) {
    let url = new URL(window.location);
    let locationPathName = location.pathname;
    let attributes = getAndUpdateSelectedSiblingAttributes(
        url,
        false,
        shouldNotSetQueryParam
    );
    if (!shouldNotSetQueryParam) {
        window.history.replaceState(
            {
                name: 'pdpSinglePage-' + locationPathName,
                url: locationPathName,
                validProduct: attributes.data.validProduct,
                attributes: attributes.currentSelectedValues
            },
            '',
            url
        );
    }
    return attributes.data;
}

/**
 * handle attribute selection during page load and attribute click
 * @param {Object} param0 Collection of attribute level info such as url, container and tracking information
 * @param {function} cb Callback function
 */
var handleAttributeSelection = function ({
    selectedVariationUrl,
    $productContainer,
    isOptionClicked,
    trackingData,
    isVariation
} = {}) {
    let data =
        isBuyBoxOnPDPEnabled === 'true' ? handleSiblingAttributes(true) : null;
    let variationUrl;
    let $productDetailsContainer;

    variationUrl =
        selectedVariationUrl || $('#defaultVariationUrl').val() || '';
    $productDetailsContainer = $productContainer || $('.product-detail');

    var $bundleItem = $('.bundle-product-item', $productDetailsContainer);
    if ($bundleItem.length) {
        variationUrl = $('#bundleProductURL', $bundleItem).val();
    }
    if (
        data &&
        typeof data.validProduct !== 'undefined' &&
        !data.validProduct
    ) {
        $('body').trigger('product:beforeAttributeSelect', {
            container: $productDetailsContainer,
            optionElement: isOptionClicked
        });
        $('body').trigger('product:siblingProductClicked', data);
    } else {
        attributeSelect(
            variationUrl,
            $productDetailsContainer,
            isOptionClicked,
            trackingData,
            false,
            () => {
                if (!isVariation)
                    $('body').trigger('product:googleAIRecommeLoad');
            }
        );
    }

    if (isBuyBoxOnPDPEnabled === 'true') {
        setAttributeLabelsToSelection();
    }
};

/**
 * handle condition attribute variation click
 * @param {Event} e click event
 * @param {boolean} isOptionClicked is warranty option click check
 */
var handleVariationClick = function (e, isOptionClicked = false) {
    e.preventDefault();

    if (
        $(this).hasClass('selected') ||
        $(this).hasClass('disabled') ||
        $(this).hasClass('unselectable')
    ) {
        return;
    }

    const isVariation = true;
    const selectedVariationUrl =
        (window.pdpBuyBox && window.pdpBuyBox.selectedUrl) ||
        $(this).data('url');
    let $productContainer = $(this).closest('.set-item');
    const $allAttributes =
        isBuyBoxOnPDPEnabled === 'true'
            ? $('.attribute:not(.sibling-attributes-redesign .platform)')
            : $('.attribute:not(.sibling-attributes .platform)');
    if (!$productContainer.length) {
        $productContainer = $(this).closest('.product-detail');
    }

    if (isBuyBoxOnPDPEnabled === 'true') {
        const attributeName = $(this).closest('[data-attr]').data('attr');

        if (!selectedVariationUrl) {
            const $allColorAttributes = $productContainer.find(
                `[data-attr="${attributeName}"] [data-attr-value]`
            );
            $allColorAttributes.removeClass('selected').removeAttr('selected');
            $(this).addClass('selected').attr('selected', 'selected');
        }
    }

    const trackingData = {
        label: $.trim($(this).find('.condition-label').text()).replace(
            /[^a-zA-Z- ]/g,
            ''
        ),
        action: $.trim($(this).parents('.attribute').children('label').text()),
        position: $allAttributes.index($(this).parents('.attribute')) + 1,
        productSKU: $productContainer.data('pid')
    };

    handleAttributeSelection({
        selectedVariationUrl,
        $productContainer,
        isOptionClicked,
        trackingData,
        isVariation
    });
};

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var optionSelectType = $(this).data('option-select-type');
            var $elOption;
            var selectedValueId;

            if ($(this).closest('.product-options-redesign').length) {
                // updating 'optionSelectType'  to 'radio' for pdp redesign template

                optionSelectType = 'radio';
            }

            if (optionSelectType === 'radio') {
                $elOption = $(
                    'input[type=radio][name^="option-"]:checked',
                    $(this)
                );
                selectedValueId = $elOption.data('value-id');
            } else {
                $elOption = $(this).find('.options-select');
                var urlValue = $elOption.val();
                selectedValueId = $elOption
                    .find('option[value="' + urlValue + '"]')
                    .data('value-id');
            }
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        })
        .toArray();
    var isPURProduct = $productContainer.attr('data-pur-product');
    if (isPURProduct && isPURProduct === 'true') {
        options = options.filter(function (e) {
            return e.optionId === 'magazineFormat';
        });
    } else {
        options = options.filter(function (e) {
            return e.optionId !== 'magazineFormat';
        });
    }
    return JSON.stringify(options);
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptionsOnATCModel($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var optionSelectType = 'radio';
            var $elOption;
            var selectedValueId;

            if (optionSelectType === 'radio') {
                $elOption = $(
                    'input[type=radio][name^="option-atcmodel-"]:checked',
                    $(this)
                );
                selectedValueId = $elOption.data('value-id');
            }

            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        })
        .toArray();

    return JSON.stringify(options);
}

function applyBonusProduct(bonusProductData) {
    var queryString = '?pids=';
    var url = bonusProductData.addToCartUrl;
    var pidsObject = {
        bonusProducts: []
    };

    if (bonusProductData.bonuspids.toString()) {
        pidsObject.bonusProducts.push({
            pid: bonusProductData.bonuspids.toString(),
            qty: 1,
            options: [null]
        });
        pidsObject.totalQty = 1;
    }

    queryString += JSON.stringify(pidsObject);
    queryString = queryString + '&uuid=' + bonusProductData.uuid;
    queryString = queryString + '&pliuuid=' + bonusProductData.pliUUID;

    $.spinner().start();
    $.ajax({
        url: url + queryString,
        method: 'POST',
        success: function (data) {
            if (data.error) {
                $.spinner().stop();
                $('.error-choice-of-bonus-products').html(data.errorMessage);
            } else {
                $('.minicart-quantity').html(data.totalQty);
                $('.bonus-product-button').addClass('d-none');
                $('.remove-line-item-bottom').removeClass('d-none');
                $('body').trigger('product:afterAddToCartDetails', {
                    data: data,
                    label: 'pdp'
                });
                setTimeout(function () {
                    if ($('.cart-page').length) {
                        $.spinner().stop();
                        location.reload();
                    }
                }, 3000);
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Retrieve shipping options
 * @param {jQuery} $productContainer - DOM element for current product
 *
 * @return {string} - selected shipping option value.
 */
function getShippingOptions($productContainer) {
    var shippingOption = $productContainer
        .find('.shipping-options-available input[type=radio]:checked')
        .val();

    return shippingOption;
}

/**
 * Updates the "Add to Cart" modal after "protect your purchase" action
 * @param {string} response - ajax response from clicking the "protect your purchase" button
 * @param {Object} $purchaseTarget - current object
 */
function handlePostPurchaseAdd(response, $purchaseTarget) {
    if (response.enableAddToCartModal) {
        $(
            '.redesign-atcmodal #addedToCartModal ' +
                $purchaseTarget +
                ' .line-item-total-price .price .sales .value'
        ).replaceWith(response.itemTotal);
        if (
            $(
                '.redesign-atcmodal #addedToCartModal ' +
                    $purchaseTarget +
                    ' .line-item-total-price .price .list .value'
            ).length > 0 &&
            response.itemListPrice
        ) {
            $(
                '.redesign-atcmodal #addedToCartModal ' +
                    $purchaseTarget +
                    ' .line-item-total-price .price .list .value'
            ).replaceWith(response.itemListPrice);
        }
        $(
            '.redesign-atcmodal #addedToCartModal ' +
                $purchaseTarget +
                ' .line-item-total-price .pro-price-value'
        ).replaceWith(response.itemTotal);
        $(
            '.redesign-atcmodal #addedToCartModal ' +
                $purchaseTarget +
                ' .line-item-option'
        ).replaceWith(response.optionDisplayName);
        if (response.addedProductUUID) {
            $('.warrantyPliUUID').val(response.addedProductUUID);
        }

        var showCart =
            `<div class="ready-to-checkout">
				<div class="no-option-container">
        		<h5 class="section-heading">` +
            response.heading +
            `</h5>
                	<div class="gotocart-ready">
                 	<a class="goto-cart btn btn-primary" href="` +
            response.redirectUrl +
            '">' +
            response.redirectMessage +
            `</a></div>
                 </div>
             </div>`;
        $($purchaseTarget + ' .view-cart').replaceWith(showCart);
        $('.redesign-atcmodal #addedToCartModal .addtocartlink').hide();
    }
}

/**
 * show spa message on add to cart
 * @param {Object} currentObject - current object
 */
function showSPAMessage(currentObject) {
    var messageType;
    var $spaAlertPUR = $('#spa-alert-pro');
    var customerGroupCookieName = $spaAlertPUR.attr('data-customergroupcookie');
    var wrCookieName = $spaAlertPUR.attr('data-wrcookie');
    var customerGroups = getCookie(customerGroupCookieName);

    // remove message if already available
    $('.add-to-cart-messages-spa').remove();

    if (
        customerGroups &&
        (customerGroups.includes('PUR-Pro') ||
            customerGroups.includes('PUR-Elite')) &&
        getCookie(wrCookieName) !== 'true'
    ) {
        messageType = $('#spa-alert-pro').val();
    } else {
        messageType = $('#spa-alert').val();
    }
    var selector = currentObject.closest('.add-to-cart-buttons');
    if (messageType === 'null') {
        currentObject.attr('disabled', true);
    } else {
        currentObject.attr('disabled', true);
        var $pdpContainer = $('#product-detail-redesign');
        if ($pdpContainer) {
            $('#primary-details-row')
                .find('.add-to-cart-buttons .js-add-to-cart')
                .attr('disabled', true);
            $('.sticky-header')
                .find('.add-to-cart-buttons .js-add-to-cart')
                .attr('disabled', true);
            $('.last-visited-redesign')
                .find('.product.grid-tile:nth-child(1) .add-to-cart-plp')
                .attr('disabled', true);
        }
        if (selector.find('.add-to-cart-messages-spa').length === 0) {
            selector.append('<div class="add-to-cart-messages-spa"></div>');
        }
        selector
            .find('.add-to-cart-messages-spa')
            .append(
                '<div class="alert add-to-basket-alert text-center" role="alert">' +
                    messageType +
                    '</div>'
            );
        setTimeout(function () {
            $('.add-to-cart-messages-spa').remove();
        }, 5000);
    }
}

/**
 * @param {Object} response - current response
 */
function showCaptcha(response) {
    var $recaptchaResponse = $($.trim(response.addedToCartModalMarkup));
    $('body').append($recaptchaResponse);
    $('#recaptchaModal').modal('show');

    $('#recaptchaModal').on('hide.bs.modal', function () {
        $('#recaptchaModal').remove();
        $('.modal-backdrop').remove();
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button, also
 * shows "Add to Cart" modal
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {Object} currentObject - current object
 */
function handlePostCartAdd(response, currentObject) {
    $('.minicart').trigger('count:update', response);
    $('.minicart').trigger('minicartheader:update');
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (
        response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0
    ) {
        applyBonusProduct(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages"></div>');
        }

        if ($('.pur-renew-modal').length > 0) {
            $('.add-to-cart-messages').append(
                '<div class="alert ' +
                    messageType +
                    ' add-to-basket-alert text-center" role="alert">' +
                    '<div class="alert-msg">' +
                    response.message +
                    '</div>' +
                    response.cartLink +
                    '</div>'
            );
        } else if (response.enableAddToCartModal) {
            if (
                $('.product-detail').length &&
                $('.quick-view-dialog').length === 0 &&
                response.error
            ) {
                $('.add-to-cart-buttons').prepend(
                    '<div class="alert ' +
                        messageType +
                        ' add-to-basket-inline text-center" role="alert">' +
                        '<div class="alert-msg">' +
                        response.message +
                        '</div>' +
                        response.cartLink +
                        '</div>'
                );
            } else if (response.error) {
                $('.add-to-cart-messages').append(
                    '<div class="alert ' +
                        messageType +
                        ' add-to-basket-alert text-center" role="alert">' +
                        '<div class="alert-msg">' +
                        response.message +
                        '</div>' +
                        response.cartLink +
                        '</div>'
                );
            }
        } else {
            // eslint-disable-next-line
            if (
                $('.gift-card-redesign').length === 0 &&
                $('.product-detail').length &&
                $('.quick-view-dialog').length === 0 &&
                currentObject
            ) {
                var selector = currentObject.closest('.add-to-cart-buttons');
                selector.prepend(
                    '<div class="alert ' +
                        messageType +
                        ' add-to-basket-inline text-center" role="alert">' +
                        '<div class="alert-msg">' +
                        response.message +
                        '</div>' +
                        response.cartLink +
                        '</div>'
                );
            } else {
                $('.add-to-cart-messages').append(
                    '<div class="alert ' +
                        messageType +
                        ' add-to-basket-alert text-center" role="alert">' +
                        '<div class="alert-warning-icon"></div>' +
                        '<div class="alert-msg">' +
                        response.message +
                        '</div>' +
                        response.cartLink +
                        '</div>'
                );
            }
        }

        setTimeout(function () {
            $('.add-to-basket-alert, .add-to-basket-inline').remove();
        }, 5000);
    }

    if (
        response.enableAddToCartModal &&
        response.addedToCartModalMarkup != null
    ) {
        if ($('#addedToCartModal').length) {
            $('#addedToCartModal').remove();
            $('.modal-backdrop').remove();
        }

        var $addedToCartModalMarkup = $(
            $.trim(response.addedToCartModalMarkup)
        );

        $('body').append($addedToCartModalMarkup);
        if (!response.inventoryOOSModal) {
            $('#addedToCartModal').modal('show');
        }
        $('body').trigger('product:afterAddToCartModal');

        if ($('.redesign-atcmodal').find('#addedToCartModal').length === 1) {
            var warrantyOptionsATCMaster = $(
                '.redesign-atcmodal #addedToCartModal .master-product .warranty-option-atcmodal'
            );
            var warrantyOptionsATCRecomm = $(
                '.redesign-atcmodal #addedToCartModal .upsell-product .warranty-option-atcmodal'
            );

            var labelStylingMaster = $(
                '.redesign-atcmodal #addedToCartModal .master-product .radio-option-plan'
            );
            var labelStylingRecom = $(
                '.redesign-atcmodal #addedToCartModal .upsell-product .radio-option-plan'
            );
            var warrantyOnMaster = warrantyOptionsATCMaster.length;
            var warrantyOnRecomm = warrantyOptionsATCRecomm.length;
            // with new design button should not be disabled.
            var disableSingleWarrantyCheckbox = false;
            if (disableSingleWarrantyCheckbox && warrantyOnMaster === 1) {
                $(warrantyOptionsATCMaster)
                    .prop('checked', true)
                    .css('visibility', 'hidden');
                $('.protect-your-purchase.btn').prop('disabled', false);
                $(
                    '.redesign-atcmodal #addedToCartModal .master-product .checkmark'
                ).css('visibility', 'hidden');
                $(labelStylingMaster)
                    .addClass('shift-plan mark-check')
                    .parent()
                    .addClass('one-plan');
            }
            if (warrantyOnRecomm === 1) {
                $(warrantyOptionsATCRecomm)
                    .prop('checked', true)
                    .css('visibility', 'hidden');
                $('.protect-your-purchase.btn').prop('disabled', false);
                $(
                    '.redesign-atcmodal #addedToCartModal .upsell-product .checkmark'
                ).css('visibility', 'hidden');
                $(labelStylingRecom)
                    .addClass('shift-plan mark-check')
                    .parent()
                    .addClass('one-plan');
            }
            atcWarantyModal.handleATCModalWarranty();
        }
        $('#product-recommendations-atc').html(
            $('#hidden-product-recommendations-atc').html()
        );
        $('#hidden-product-recommendations-atc').remove();
        var promotionRecommendationUrl = $('.promotion_recommendation').data(
            'url'
        );
        if (promotionRecommendationUrl) {
            $.ajax({
                url: promotionRecommendationUrl,
                type: 'get',
                success: function (data) {
                    var slickConfigs = require('org/config/slickConfigs');
                    $('.promotion_recommendation').html(data);
                    $(
                        '.promotion_recommendation .recommended-products-caro'
                    ).slick(slickConfigs.recommendedProductsRedesignATC);
                }
            });
        }
    }

    // for inventoryModal
    if (response.inventoryOOSModal && response.inventoryOOSModalMarkup) {
        if ($('#addedToCartModal').length) {
            $('.modal-backdrop').remove();
        }

        var $inventoryModal = $($.trim(response.inventoryOOSModalMarkup));

        $('body').append($inventoryModal);
        $('#inventoryModal').modal('show');
    }

    var $purUpgradeBanner = $('.order-confirmation-pur-banner');
    var $playerUpgradeModal = $('#playerUpgradeModal');
    var $proRenewModal = $('#proRenewModal');

    if (
        $playerUpgradeModal.hasClass('show') ||
        $proRenewModal.hasClass('show')
    ) {
        $playerUpgradeModal.modal('hide');
        $proRenewModal.modal('hide');

        $(document).on('hide.bs.modal', '#addedToCartModal', function () {
            if ($purUpgradeBanner.length) {
                window.location.href = $purUpgradeBanner.data('url');
            }
        });

        window.location.reload();
    }
}

/**
 * handle click event for delivery options in pdp page
 * @param {jQuery} _this - current selected radio button
 */
function handleShippingOptionChange(_this) {
    var pid = _this.data('pid');
    var value = _this.val();
    var $varientStoreInput = $('input#storeDetail-' + pid);
    var $productContainer = _this.closest('.product-detail');
    var $addToCartButton = $('.js-add-to-cart', $productContainer);
    var $selectedStoreDetails = $('.selected-store-details', $productContainer);
    var $shippingPromotion = $(
        '.shipping-promotions .callout',
        $productContainer
    );
    var $addressDetails = $('.selected-address-details', $productContainer);
    var url = $('.same-day-delivery.js-same-day-delivery').attr(
        'data-actionurl'
    );
    var $getStartedButton = $('#getting-started-btn');
    var $applePay = $('.apple-pay-pdp', $productContainer);
    var $nonSddPromo = $('.nonSddPromo', $productContainer);
    var $sddPromo = $('.sddPromo', $productContainer);
    var $variantAddToCartButton = $('button.variant-add-to-cart');
    var disclaimerButtonText = $('#disclaimer-atc-button-text').val();
    var asterisk = $('<span class="add-cart-asterisk">*</span>');

    if ($variantAddToCartButton.length) {
        $('.add-cart-asterisk').remove();
    }

    if (value === 'store') {
        $selectedStoreDetails.removeClass('hide');
        if (
            !$('.store-unavailable-message').hasClass('hide') &&
            $('.storepickup-unavailable').length !== 0 &&
            $getStartedButton.length !== 0
        ) {
            $getStartedButton.attr('disabled', 'disabled');
        }
        $shippingPromotion.addClass('hide');
        $addressDetails.addClass('hide');
        $addToCartButton.removeAttr('disabled');
        $applePay.removeClass('d-none');
        if ($variantAddToCartButton.length) {
            $('.add-to-cart-disclaimer').text(disclaimerButtonText);
            $variantAddToCartButton.prepend(asterisk);
            $('.variantID .add-to-cart-disclaimer').show();
        } else {
            $('.variantID .add-to-cart-disclaimer').hide();
        }

        if (!$varientStoreInput.length) {
            $addToCartButton.attr('disabled', 'disabled');
            $variantAddToCartButton.removeAttr('disabled');
            $applePay.addClass('d-none');
            if (
                $('#hideOOSFulfillmentTile').val() === 'true' &&
                $('.delivery-out-of-stock.hide').length === 0
            ) {
                $('.shipping-options-available').addClass('d-none');
            }
        }
        $nonSddPromo.addClass('hide');
        $sddPromo.addClass('hide');
    }

    if (value === 'home') {
        $addToCartButton.removeAttr('disabled');
        if ($getStartedButton.attr('disabled')) {
            $getStartedButton.removeAttr('disabled');
        }
        $selectedStoreDetails.addClass('hide');
        $shippingPromotion.removeClass('hide');
        $addressDetails.addClass('hide');
        $applePay.removeClass('d-none');
        $nonSddPromo.removeClass('hide');
        $sddPromo.addClass('hide');
        $('.variantID .add-to-cart-disclaimer').hide();
    }

    if (value === 'delivery') {
        getSDDResponse(url);
        $selectedStoreDetails.addClass('hide');
        $shippingPromotion.addClass('hide');
        $addressDetails.removeClass('hide');
        $applePay.addClass('d-none');
        $sddPromo.removeClass('hide');
        $nonSddPromo.addClass('hide');
        if ($variantAddToCartButton.length) {
            $('.add-to-cart-disclaimer').text(disclaimerButtonText);
            $variantAddToCartButton.prepend(asterisk);
            $('.variantID .add-to-cart-disclaimer').show();
        } else {
            $('.variantID .add-to-cart-disclaimer').hide();
        }
    }
}

/**
 * Updates PDP on sibling product click
 * @param {Object} data - data object
 */
function handleSiblingProductClick(data) {
    if (isBuyBoxOnPDPEnabled === 'true' && data.targetValue === 'null') {
        return;
    }

    $('.modal.show').modal('hide');
    let locationPathName = location.pathname;
    let dataObj = data;
    let url = new URL(window.location);
    let targetValueUrl = new URL(data.targetValue, location.origin);
    const isEditionExpanded = url.searchParams.get('editionexpanded');
    if (isEditionExpanded && isEditionExpanded === 'true') {
        targetValueUrl.searchParams.set('editionexpanded', 'true');
        dataObj.targetValue = targetValueUrl.toString();
    }
    dataObj.validProduct = true;
    let state = {
        name: 'pdpSinglePage-' + locationPathName,
        url: locationPathName,
        validProduct: true
    };

    // Replace history state for first time page load
    if (window.history.state === null) {
        window.history.replaceState(state, '', locationPathName);
    }

    // Push new state in history with clicked sibling product URL
    if (
        data.originalEvent &&
        $(data.originalEvent) &&
        $(data.originalEvent).hasClass('unselectable') &&
        isBuyBoxOnPDPEnabled === 'true'
    ) {
        let $currentSiblingAttr = $(data.originalEvent);
        let currentSiblingSelected = $currentSiblingAttr
            .closest('.sibling-attribute')
            .data('sibling-value');
        let $currentSiblingSelected = $(
            '.select-' + currentSiblingSelected + ' .options-select[selected]'
        );
        $currentSiblingSelected.removeAttr('selected');
        let $currentSiblingAttributes = $(
            '.select-' +
                currentSiblingSelected +
                ' .options-select[data-attr-value=' +
                $currentSiblingAttr.data('attrValue') +
                ']'
        );
        $currentSiblingAttributes.attr('selected', 'selected');
        let attributes = getAndUpdateSelectedSiblingAttributes(
            url,
            false,
            true
        );
        dataObj.validProduct = false;
        state.validProduct = false;
        state.attributes = attributes.currentSelectedValues;
        window.history.pushState(state, '', url);
    } else {
        state.name = 'pdpSinglePage-' + dataObj.targetValue;
        state.url = dataObj.targetValue;
        window.history.pushState(state, '', targetValueUrl);
    }
    productVariationNotifyMeState.empty = true;

    $('body').trigger('product:siblingProductClicked', dataObj);
}

/**
 * pass suggestion status to GTM
 * @param {string} layerEvent text
 * @return {string} - selected data
 *
 */
function filterDataLayer(layerEvent) {
    var dataLayer = window.dataLayer;
    var productViewObj = dataLayer.filter(function (item) {
        return item.event === layerEvent;
    });
    return productViewObj;
}

/**
 *  Add PDP list for ATC Modal | Warranty
 */
function updateWarrantyList() {
    var selectedID = $('.warranty-option-atcmodal.current-option').data(
        'value-id'
    );
    var productViewedObject = filterDataLayer('Product Viewed');
    if (productViewedObject.length) {
        var warrentyPrice = null;
        var warrantyProduct = filterDataLayer('Product Viewed')[0].product;
        selectedID =
            selectedID === undefined
                ? warrantyProduct[1].productInfo.productID
                : selectedID;
        for (var i = window.dataLayer.length - 1, l = 0; i >= l; --i) {
            if (window.dataLayer[i].event === 'Product Added') {
                var productData = window.dataLayer[i];
                var quantity =
                    window.dataLayer[i].product[0] === undefined
                        ? 1
                        : window.dataLayer[i].product[0].quantity;
                productData.list = {
                    listName: 'PDP ATC Modal | Warranty'
                };
                var productViewObj = warrantyProduct.filter(function (item) {
                    return item.productInfo.productID === selectedID;
                });
                if (productViewObj[0]) {
                    productViewObj[0].quantity = quantity;
                    window.dataLayer[i].product.splice(0, 1, productViewObj[0]);
                }
                window.dataLayer.splice(
                    i,
                    1,
                    $.extend(window.dataLayer[i], productData)
                );
                if (window.dataLayer[i].product[0]) {
                    window.dataLayer[i].product[0].productInfo.zoneSource =
                        'PDP ATC Modal';
                    warrentyPrice = window.dataLayer[i].product[0].price;
                }
                if (warrentyPrice) {
                    warrentyPrice.basePrice = warrentyPrice.basePrice.replace(
                        '$',
                        ''
                    );
                    warrentyPrice.sellingPrice =
                        warrentyPrice.sellingPrice.replace('$', '');
                    warrentyPrice.currency = 'USD';
                }
                break;
            }
        }
    }
}

/**
 * Deconstruct (unslick) the carousel, removing classes and handlers added on slick initialize.
 */
function carouselUnslick() {
    if (
        $('.product-carousel').length &&
        $('.product-carousel').slick &&
        $('.product-carousel').hasClass('slick-initialized')
    ) {
        $('.product-carousel').slick('unslick');
    }
}

// FIXME possible duplication with existing logic which shows currently unavailable

$('body').on('product:loadProductDescription', function () {
    if ($('#product-detail-redesign').length) {
        var $mainWishListElem = $(
            '.main-wishlist .wishlist-and-trade-section-redesign .add-to-library'
        );
        var $desktopWishlist = $('.desktop-wishlist');
        if ($mainWishListElem.length) {
            var $mainWishlist = $mainWishListElem.clone();
            var $placeWishlist = $(
                '.wishlist-and-trade-section-redesign .wishlist-and-trade',
                $desktopWishlist
            );
            $placeWishlist.html($mainWishlist);
            $desktopWishlist.removeClass('d-none');
            $desktopWishlist.addClass('d-md-block');
        } else {
            $desktopWishlist.addClass('d-none');
            $desktopWishlist.removeClass('d-md-block');
        }
        if (
            $(
                '.main-wishlist .wishlist-and-trade-section-redesign .trade-value'
            ).length
        ) {
            var $mainTrade = $(
                '.main-wishlist .wishlist-and-trade-section-redesign .trade-value'
            ).clone();
            var $placeTrade = $(
                '.desktop-trade .wishlist-and-trade-section-redesign .wishlist-and-trade'
            );
            $placeTrade.html($mainTrade);
            var $placeWishlistPopup = $(
                '.desktop-trade .wishlist-and-trade-section-redesign .wishlist-and-trade .trade-value'
            );
            var $mainWishlistPopup = $(
                '.main-wishlist .wishlist-and-trade-section-redesign .library-modal'
            ).clone();
            $mainWishlistPopup.insertBefore($placeWishlistPopup);
        }
    }
});

$('body').on('shown.bs.modal', '#inventoryModal', function () {
    $('body').on('click', '.proceed-button', function (e) {
        e.preventDefault();
        if ($('#inventoryModal').length) {
            $('#inventoryModal').remove();
            $('.modal-backdrop').remove();
        }

        $('#addedToCartModal').modal('show');
    });
});

function removeModalBodyClass() {
    if ($('body').hasClass('modal-open')) {
        $('body').removeClass('modal-open');
    }
}

$('body').on('hide.bs.modal', function () {
    $('.modal-backdrop').remove();
    removeModalBodyClass();
});

$('body').on('click', '.modal-backdrop', function (e) {
    $('#pdpAttributeModal').modal('hide');
    removeModalBodyClass();
});

var exportBase = $.extend({}, base, {
    updatePrices: updatePrices,
    resetPrices: resetPrices,
    attributeSelect: attributeSelect,
    setAttributeLabel: setAttributeLabel,
    setAttributeLabelsToSelection: setAttributeLabelsToSelection,
    getDeliveryMessage: getDeliveryMessage,
    getProMemberFreeShippingMessage: getProMemberFreeShippingMessage,
    handleVariantResponse: handleVariantResponse,
    updateOptions: updateOptions,
    updateTradeLink: updateTradeLink,
    getOptions: getOptions,
    processSwatchValues: processSwatchValues,
    getSDDResponse: getSDDResponse,
    getSDDResponseSynchronous: getSDDResponseSynchronous,
    reRenderVariationAttrFromDataSibling: reRenderVariationAttrFromDataSibling,
    setBuyable: setBuyable,
    setUrl: setUrl,
    setValidAttributesBasedOnSelection: setValidAttributesBasedOnSelection,
    resetFulfillmentFlags: resetFulfillmentFlags,
    toggleProductPrimaryDetailsDisplay: toggleProductPrimaryDetailsDisplay,
    getCookie: getCookie,
    methods: {
        handlePostCartAdd: handlePostCartAdd
    },
    carouselUnslick: carouselUnslick,

    selectAttribute: function () {
        $(document)
            .off('.selectAttribute')
            .on(
                'change.selectAttribute',
                'select[class*="select-"], .options-select, input[type=radio][name^="option-"]',
                function (e) {
                    e.preventDefault();
                    var $productContainer = $(this).closest('.set-item');
                    var $productOptionValue = $(this).closest(
                        '.product-options-redesign'
                    );
                    var $allAttributes =
                        isBuyBoxOnPDPEnabled === 'true'
                            ? $(
                                  '.attribute:not(.sibling-attributes-redesign .platform)'
                              )
                            : $(
                                  '.attribute:not(.sibling-attributes .platform)'
                              );
                    var $selectedOption = $(this).find('option:selected');
                    var isOptionClicked = false;
                    if (!$productContainer.length) {
                        $productContainer = $(this).closest('.product-detail');
                    }
                    if ($productOptionValue.length) {
                        isOptionClicked = true;
                    } else {
                        isOptionClicked = false;
                    }

                    // construct data for gtm tracking
                    const trackingData = !$(this).hasClass('warranty-option')
                        ? {
                              label: $.trim($selectedOption.text()),
                              action: $.trim(
                                  $(this)
                                      .parents('.attribute')
                                      .children('label')
                                      .text()
                              ),
                              position:
                                  $allAttributes.index(
                                      $(this).parents('.attribute')
                                  ) + 1,
                              productSKU: $productContainer.data('pid')
                          }
                        : false;

                    var siblingDetails = $productContainer.data('sibling');
                    var targetValue = $(e.currentTarget)
                        .find('option:selected')
                        .attr('value');
                    var targetProductId = $selectedOption.data('productId');

                    if (
                        !isOptionClicked &&
                        isBuyBoxOnPDPEnabled === 'true' &&
                        (!targetValue || targetValue === '')
                    )
                        return;

                    if (siblingDetails && siblingDetails.length) {
                        // Update new product URL if sibling details are availble
                        var currentSiblingSelected = $(this)
                            .closest('.sibling-attribute')
                            .data('sibling-value');
                        var currentSiblingValue = $(this)
                            .find(':selected')
                            .data('attrValue');
                        var currentSelectedValues = {};
                        var $siblingAttributes =
                            isBuyBoxOnPDPEnabled === 'true'
                                ? $(
                                      '.sibling-attributes-redesign .sibling-attribute'
                                  )
                                : $('.sibling-attributes .sibling-attribute');

                        $siblingAttributes.each(function () {
                            if (
                                $(this).data('sibling-value') !==
                                currentSiblingSelected
                            ) {
                                if (
                                    $(this).find(
                                        'select.select-sibling-attribute'
                                    ).length
                                ) {
                                    currentSelectedValues[
                                        $(this).data('sibling-value')
                                    ] = $(this)
                                        .find(
                                            'select.select-sibling-attribute [selected]'
                                        )
                                        .data('attr-value');
                                } else {
                                    currentSelectedValues[
                                        $(this).data('sibling-value')
                                    ] = $(this)
                                        .find('li[selected]')
                                        .data('attrValue');
                                }
                            }
                        });

                        siblingDetails.filter((obj) => {
                            let noData = false;
                            for (const key of Object.keys(
                                currentSelectedValues
                            )) {
                                if (obj[key] !== currentSelectedValues[key]) {
                                    noData = true;
                                }
                            }

                            if (
                                !noData &&
                                obj[currentSiblingSelected] ===
                                    currentSiblingValue
                            ) {
                                targetValue = obj.url;
                            }

                            return true;
                        });
                    }

                    if ($(this).hasClass('select-sibling-attribute')) {
                        if (
                            !$('#quickViewModal').is(':visible') &&
                            !$('#editProductModal').is(':visible')
                        ) {
                            let $singlePageInput = $('#singlePageRefresh');

                            if (
                                $singlePageInput.length &&
                                $singlePageInput.val() === 'true'
                            ) {
                                let data = {
                                    targetValue: targetValue,
                                    productContainer: $productContainer,
                                    targetProductId
                                };
                                const siblingProductData = Object.assign(
                                    data,
                                    { trackingData },
                                    { originalEvent: $selectedOption }
                                );
                                handleSiblingProductClick(siblingProductData);
                            } else {
                                window.location.href = e.currentTarget.value;
                            }
                        }
                    } else {
                        attributeSelect(
                            e.currentTarget.value,
                            $productContainer,
                            isOptionClicked,
                            trackingData,
                            false
                        );
                    }
                    var platfromSelected = '#platfrom-selected';
                    var platfromSelectedOption =
                        platfromSelected + ' option:selected';
                    var platfromSelectedSet = '#platfrom-selected-set';
                    var platfromSelectedSetFirst =
                        platfromSelectedSet + ' option:first';
                    var desktopSelect = '.desktop-selection ';
                    var mobileSelect = '.mobile-selection ';
                    $(desktopSelect + platfromSelectedSetFirst).text(
                        $(desktopSelect + platfromSelectedOption).text()
                    );
                    $(desktopSelect + platfromSelected).css(
                        'width',
                        $(desktopSelect + platfromSelectedSet).width() + 20
                    );
                    $(mobileSelect + platfromSelectedSetFirst).text(
                        $(mobileSelect + platfromSelectedOption).text()
                    );
                    $(mobileSelect + platfromSelected).css(
                        'width',
                        $(mobileSelect + platfromSelectedSet).width() + 5
                    );

                    setAttributeLabelsToSelection();
                }
            );
        $(document)
            .off('.siblingAttribute')
            .on(
                'click.siblingAttribute',
                '.select-sibling-attribute .options-select, .edition-attribute a',
                function (e) {
                    e.preventDefault();

                    var $productContainer = $(this).closest('.set-item');
                    var $allAttributes =
                        isBuyBoxOnPDPEnabled === 'true'
                            ? $(
                                  '.attribute:not(.sibling-attributes-redesign .platform)'
                              )
                            : $(
                                  '.attribute:not(.sibling-attributes .platform)'
                              );
                    if (!$productContainer.length) {
                        $productContainer = $(this).closest('.product-detail');
                    }

                    var targetValue = e.currentTarget.getAttribute('value');
                    var targetProductId = e.currentTarget.dataset.productId;
                    var siblingDetails = $productContainer.data('sibling');

                    if (
                        isBuyBoxOnPDPEnabled === 'true' &&
                        (!targetValue || targetValue === '')
                    )
                        return;

                    if (siblingDetails.length) {
                        // Update new product URL if sibling details are availble
                        var currentSiblingSelected = $(this)
                            .closest('.sibling-attribute')
                            .data('sibling-value');
                        var currentSiblingValue = $(this).data('attrValue');
                        var currentSelectedValues = {};
                        var $siblingAttributes =
                            isBuyBoxOnPDPEnabled === 'true'
                                ? $(
                                      '.sibling-attributes-redesign .sibling-attribute'
                                  )
                                : $('.sibling-attributes .sibling-attribute');

                        $siblingAttributes.each(function () {
                            if (
                                $(this).data('sibling-value') !==
                                currentSiblingSelected
                            ) {
                                if (
                                    $(this).find(
                                        'select.select-sibling-attribute'
                                    ).length
                                ) {
                                    currentSelectedValues[
                                        $(this).data('sibling-value')
                                    ] = $(this)
                                        .find(
                                            'select.select-sibling-attribute [selected]'
                                        )
                                        .data('attr-value');
                                } else {
                                    currentSelectedValues[
                                        $(this).data('sibling-value')
                                    ] = $(this)
                                        .find('li[selected]')
                                        .data('attrValue');
                                }
                            }
                        });

                        siblingDetails.filter((obj) => {
                            let noData = false;
                            for (const key of Object.keys(
                                currentSelectedValues
                            )) {
                                if (obj[key] !== currentSelectedValues[key]) {
                                    noData = true;
                                }
                            }

                            if (
                                !noData &&
                                obj[currentSiblingSelected] ===
                                    currentSiblingValue
                            ) {
                                targetValue = obj.url;
                            }

                            return true;
                        });
                    }

                    // construct data for gtm tracking
                    const trackingData = {
                        label: $.trim($(this).data('attr-display-value')),
                        action: $.trim(
                            $(this)
                                .parents('.attribute')
                                .children('label')
                                .data('attrlabel')
                        ),
                        position:
                            $allAttributes.index(
                                $(this).parents('.attribute')
                            ) + 1,
                        productSKU: $productContainer.data('pid')
                    };

                    if ($(this).hasClass('edition-label')) {
                        if (
                            !$('#quickViewModal').is(':visible') &&
                            !$('#editProductModal').is(':visible')
                        ) {
                            let $singlePageInput = $('#singlePageRefresh');

                            if (
                                $singlePageInput.length &&
                                $singlePageInput.val() === 'true'
                            ) {
                                let data = {
                                    targetValue: targetValue,
                                    targetProductId,
                                    productContainer: $productContainer
                                };

                                const siblingProductData = Object.assign(
                                    data,
                                    { trackingData },
                                    { originalEvent: e.currentTarget }
                                );
                                handleSiblingProductClick(siblingProductData);
                                let $editionScrollPos = $('#editionScrollPos');
                                let $editionAttributeCont = $(
                                    '.edition-attribute.swatch-attribute'
                                );

                                if ($editionScrollPos.length) {
                                    $editionScrollPos.val(
                                        $editionAttributeCont.scrollLeft()
                                    );
                                } else {
                                    $('body').append(
                                        '<input id="editionScrollPos" type="hidden">'
                                    );
                                    $('#editionScrollPos').val(
                                        $editionAttributeCont.scrollLeft()
                                    );
                                }
                            } else {
                                window.location.href =
                                    e.currentTarget.getAttribute('value');
                            }
                        }
                    } else {
                        attributeSelect(
                            e.currentTarget.value,
                            $productContainer,
                            undefined,
                            trackingData
                        );
                    }

                    removeModalBodyClass();
                }
            );
    },

    shippingOptionChange: function () {
        $(document).on(
            'change',
            '.delivery-options-pid .delivery-option',
            function () {
                handleShippingOptionChange($(this));
            }
        );
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            var searchPID = $(this).closest('.product-detail').attr('data-pid');
            var selectorPrefix =
                '.product-detail[data-pid="' + searchPID + '"]';

            if (
                $(selectorPrefix + ' .selected-store-with-inventory').is(
                    ':visible'
                )
            ) {
                return;
            }

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this)
                    .closest('.modal-content')
                    .find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect(
                    $(e.currentTarget).find('option:selected').data('url'),
                    $productContainer
                );
            }
        });
    },

    addToCart: function () {
        $(document).on(
            'click',
            '.js-add-to-cart, button.btn-same-day-delivery, button.add-to-cart-global',
            function (e, dataCTR) {
                var addToCartUrl;
                var pid;
                var pidsObj;
                var setPids;
                var $currentObject = $(this);
                var $isinvisibleRecaptcha = $('.pdp-invisible-recaptcha');
                $('#selectedShippingOption').val(
                    $('.pdp-delivery-option-button.selected')
                        .first()
                        .data('optionvalue')
                );

                if ($isinvisibleRecaptcha.length) {
                    if (!(dataCTR && dataCTR.ctr)) {
                        window.grecaptcha.execute();
                        return;
                    }
                }
                // show spinner on add to cart
                // there is so much extra logic attached to the trigger product:beforeAddToCart like injecting css
                $('body').trigger('product:beforeAddToCart', this);

                if (
                    $('.set-items').length &&
                    $(this).hasClass('add-to-cart-global')
                ) {
                    setPids = [];

                    $('.product-detail').each(function () {
                        if (!$(this).hasClass('product-set-detail')) {
                            setPids.push({
                                pid: $(this).find('.product-id').text(),
                                qty: $(this).find('.quantity-select').val(),
                                options: getOptions($(this))
                            });
                        }
                    });
                    pidsObj = JSON.stringify(setPids);
                }

                pid = base.getPidValue($(this));
                var recZone = '';
                var upsellID = '';
                if ($(this).hasClass('variant-add-to-cart')) {
                    recZone = '1';
                    if (
                        $('.option-to-add').css('display') !== 'none' &&
                        $('.option-to-add').css('display') !== undefined
                    ) {
                        var $addOption = $('.option-to-add');
                        if (
                            $addOption
                                .find('input#add-recomm-product')
                                .prop('checked')
                        ) {
                            upsellID = $('.additional-set-products')
                                .find('.product.grid-tile')
                                .attr('data-pid');
                            recZone = '2';
                        } else {
                            pid = $('.additional-set-products')
                                .find('.product.grid-tile')
                                .attr('data-pid');
                        }
                    } else if (
                        $('.bothProds-complete-set').css('display') !==
                            'none' &&
                        $('.bothProds-complete-set').css('display') !==
                            undefined
                    ) {
                        var $otherProd = $('.variantID .product.grid-tile');
                        upsellID = $otherProd.data('pid');
                        recZone = '2';
                    } else {
                        pid = $(
                            '.additional-set-products .single-recommendation .product.grid-tile'
                        ).attr('data-pid');
                    }
                }

                var $productContainer = $(this).closest('.product-detail');
                if (!$productContainer.length) {
                    $productContainer = $(this)
                        .closest('.quick-view-dialog')
                        .find('.product-detail');
                }

                var purPROID;
                var purProMagazineFormat;
                var $purSignupContainer = $('.signup-checkbox-container');
                if (
                    $purSignupContainer.length &&
                    $purSignupContainer.find('input').prop('checked')
                ) {
                    purPROID = $purSignupContainer
                        .find('.pro-sku-select')
                        .data('pur-product-id');
                    purProMagazineFormat = $purSignupContainer
                        .find('input')
                        .data('value-id');
                } else {
                    purPROID = '';
                }
                var pdName = $(this).data('gtmdata');
                var productName = pdName.productInfo.name;
                addToCartUrl = base.getAddToCartUrl();
                addToCartUrl = utils.appendParamToURL(
                    addToCartUrl,
                    'productID',
                    pid
                );
                var form = {
                    pid: pid,
                    pidsObj: pidsObj,
                    upsellID: upsellID,
                    childProducts: base.getChildProducts(),
                    quantity: base.getQuantitySelected($(this)),
                    purPROID: purPROID,
                    purProMagazineFormat: purProMagazineFormat
                };

                if (
                    !$('.bundle-item').length &&
                    (!$(this).hasClass('variant-add-to-cart') ||
                        (upsellID !== '' && upsellID !== null))
                ) {
                    form.options = getOptions($productContainer);
                }

                if ($('.shipping-options-available').length) {
                    form.isSDD = false;

                    // get selected deliver options
                    var $selectedShippingOption = $('#selectedShippingOption');
                    form.deliveryOption = $selectedShippingOption.val();

                    if ($selectedShippingOption.val() === 'store') {
                        const storeID = $selectedShippingOption.data('storeId');

                        form.storeId = storeID;
                        form.storeInventoryCount =
                            $selectedShippingOption.data('inventory');
                    }

                    if ($selectedShippingOption.val() === 'delivery') {
                        form.isSDD = true;
                    }
                }

                if (recZone.length) {
                    form.recZone = recZone;
                    form.deliveryOption = 'home';
                    form.isSDD = false;
                    form.storeId = '';
                    form.storeInventoryCount = '';
                }
                form.pageSpecified = 'PDP';
                form.recommTitle = $.trim(
                    $('.complete-the-set').not('.d-none').text()
                );

                if (dataCTR && dataCTR.ctr) {
                    form['g-recaptcha-response'] = dataCTR.ctr;
                }
                $(this).trigger('updateAddToCartFormData', form);
                if (addToCartUrl) {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success: function (data) {
                            if (
                                data.Response &&
                                data.Response === 'addtoCartWR'
                            ) {
                                showSPAMessage($currentObject);
                                $('body').trigger(
                                    'product:afterAddToCartSPA',
                                    productName
                                );
                            } else if (
                                (data.protectedCaptchaCheckEnabled &&
                                    data.protectedItemFlag) ||
                                data.reCaptchaNotValidated
                            ) {
                                // Showing Captcha for protected SKUs
                                showCaptcha(data);
                            } else {
                                handlePostCartAdd(data, $currentObject);
                            }
                            if (
                                !(
                                    data.protectedItemFlag ||
                                    data.reCaptchaNotValidated ||
                                    data.error
                                )
                            ) {
                                $('body').trigger(
                                    'product:afterAddToCartDetails',
                                    { data: data, label: 'pdp' }
                                );
                                setTimeout(function () {
                                    $('body').trigger(
                                        'product:afterAddToCart',
                                        data
                                    );
                                }, 3000);
                            }
                            $('body').trigger('store:removeCachedHtml');
                            $.spinner().stop();
                        },
                        error: function () {
                            $.spinner().stop();
                        }
                    });
                }
            }
        );
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.bonus-product-button', function () {
            var queryString = '?pids=';
            var url = $('.bonus-product-button').data('url');
            var pidsObject = {
                bonusProducts: []
            };

            if ($(this).data('pid')) {
                pidsObject.bonusProducts.push({
                    pid: $(this).data('pid'),
                    qty: 1,
                    options: [null]
                });
                pidsObject.totalQty = 1;
            }

            queryString += JSON.stringify(pidsObject);
            queryString =
                queryString +
                '&uuid=' +
                $('.bonus-product-button').data('duuid');
            queryString =
                queryString +
                '&pliuuid=' +
                $('.bonus-product-button').data('pliuuid');

            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    if (data.error) {
                        $.spinner().stop();
                        $('.error-choice-of-bonus-products').html(
                            data.errorMessage
                        );
                    } else {
                        $('.minicart-quantity').html(data.totalQty);
                        $('.bonus-product-button').addClass('d-none');
                        $('.remove-line-item-bottom').removeClass('d-none');
                        $('body').trigger('product:afterAddToCartDetails', {
                            data: data,
                            label: 'cart'
                        });
                        setTimeout(function () {
                            if ($('.cart-page').length) {
                                $.spinner().stop();
                                location.reload();
                            }
                        }, 3000);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    /**
     * Updates the Product replacement plan on ATC Model and redirects user to cart.
     */
    protectYourPurchase: function () {
        $(document).on(
            'click',
            '.master-product button.protect-your-purchase, .upsell-product button.protect-your-purchase',
            function () {
                var pid;
                var pliuuid;
                var fromStoreId;
                var storeInventoryCount;
                var isSDD;
                var $purchaseTarget;

                $('.redesign-atcmodal .modal-body .view-cart')
                    .spinner()
                    .start();

                if ($(this).parents().hasClass('master-product')) {
                    $purchaseTarget = '.master-product';
                    updateWarrantyList();
                } else if ($(this).parents().hasClass('upsell-product')) {
                    $purchaseTarget = '.upsell-product';
                }

                pid = $(this).attr('data-pid');
                pliuuid = $(this).attr('data-pliuuid');
                fromStoreId = $(this).attr('data-pliFromStoreId');
                storeInventoryCount = $(this).attr(
                    'data-pliStoreInventoryCount'
                );
                isSDD = $(this).attr('data-pliIsSDD');

                var protectYourPurchaseUrl = $(this).attr(
                    'data-protectyourpurchase-url'
                );
                var $productContainer = $(this).closest(
                    '.product-options-atcmodel'
                );
                var options = getOptionsOnATCModel($productContainer);

                var form = {
                    pid: pid,
                    pliuuid: pliuuid,
                    fromStoreId: fromStoreId,
                    storeInventoryCount: storeInventoryCount,
                    options: options,
                    isSDD: isSDD
                };

                if (protectYourPurchaseUrl) {
                    $.ajax({
                        url: protectYourPurchaseUrl,
                        type: 'POST',
                        data: form,
                        dataType: 'json',
                        success: function (data) {
                            handlePostPurchaseAdd(data, $purchaseTarget);
                            if (data.error === true) {
                                window.location.href = data.redirectUrl;
                            }
                            $.spinner().stop();
                        },
                        error: function (data) {
                            window.location.href = data.redirectUrl;
                            $.spinner().stop();
                        }
                    });
                }
            }
        );

        $(document).on(
            'click',
            '#primary-details-row .view-full-text',
            function () {
                if ($('.full-content').hasClass('toggle-content')) {
                    $('.full-content').removeClass('toggle-content');
                    $('.view-full-text').html('Hide Full Warranty Details');
                } else {
                    $('.full-content').addClass('toggle-content');
                    $('.view-full-text').html('View Full Warranty Details');
                }
            }
        );

        $(document).on(
            'click',
            '#primary-details-row .product-option-details',
            function () {
                event.preventDefault();
                var optionId = $('#optionDetailModal').attr('data-option-id');
                var optionName =
                    $('#optionDetailModal').attr('data-option-name');
                var optionUrl = $('#optionDetailModal').attr('data-option-url');
                var form = {};
                form.optionId = optionId;
                form.optionName = optionName;
                form.modalType = 'warranty';
                form.contentAssetID =
                    'product-option-description-' +
                    String(optionId).toLowerCase();
                var $modalBody = $(
                    '#primary-details-row .product-options-redesign #optionDetails-' +
                        optionId
                );
                if ($modalBody.find('.modal-dialog').length === 0) {
                    $.ajax({
                        url: optionUrl,
                        type: 'GET',
                        data: form,
                        success: function (data) {
                            $modalBody.append(data.modalHtml);
                            $modalBody.modal('show');
                        }
                    });
                } else {
                    $modalBody.modal('show');
                }
                $('.full-content').addClass('toggle-content');
                $('.view-full-text').html('View Full Warranty Details');
            }
        );
    },

    protectPurchaseInit: function () {
        let self = this;
        $('body').on('protectPurchase:init', function () {
            self.protectYourPurchase();
        });
    },

    customerCheckList: function () {
        var loginCustomer = getCookie('username');

        $('body').on(
            'click',
            '.wishlist-and-trade .btn-text, .btn-text.heart-img',
            function () {
                $(this).attr('data-target', '');
                if (loginCustomer) {
                    $(this).attr('data-target', '.library-modal');
                } else {
                    var message = $(this).data('text');
                    if (!message) {
                        message =
                            'Please sign in to add this product to My Lists.';
                    }

                    if (message) {
                        if ($('.add-to-wishlist-messages').length === 0) {
                            $('body').append(
                                '<div class="add-to-wishlist-messages "></div>'
                            );
                        }
                        $('.add-to-wishlist-messages').append(
                            '<div class="add-to-wishlist-alert text-center alert-danger">' +
                                message +
                                '</div>'
                        );

                        setTimeout(function () {
                            $('.add-to-wishlist-messages').remove();
                        }, 5000);
                    }
                }
            }
        );
    },

    /*
     *  Handle Recommondation and Recently viewed products click for SPA
     */
    recommondationsSPAClick: function () {
        let $singlePageInput = $('#singlePageRefresh');

        $(document).on(
            'click',
            '#product-detail-redesign .recommended-products-caro-redesign .product-tile a, .product-detail-redesign .recently-viewed-carousel .product-tile a',
            function (e) {
                if (
                    $singlePageInput.length &&
                    $singlePageInput.val() === 'true'
                ) {
                    e.preventDefault();

                    let $anchorTag = $(e.currentTarget);

                    let data = {
                        targetValue: $anchorTag.attr('href'),
                        productContainer: $('#product-detail-redesign'),
                        productTileClicked: true
                    };

                    handleSiblingProductClick(data);
                    window.scroll(0, 0);
                }
            }
        );
    },

    conditionAttribute: function () {
        $(document)
            .off('.conditionAttribute')
            .on(
                'click.conditionAttribute',
                '.condition-attribute-card',
                handleVariationClick
            );
    },

    // Base Export Override
    colorAttribute: function () {
        $(document)
            .off('.color-swatch')
            .on(
                'click.color-swatch',
                '[data-attr="color"] .attribute-swatches a',
                function (e) {
                    e.preventDefault();
                    const $swatchElem = $(this).find('span');

                    // dont do anything if the click is on a already selected or desabled attribute
                    if (
                        $(this).attr('disabled') ||
                        $swatchElem.hasClass('unselectable') ||
                        $swatchElem.hasClass('selected')
                    ) {
                        return;
                    }

                    var url = e.currentTarget.href;
                    var $productContainer = $(this).closest('.set-item');
                    var $allAttributes =
                        isBuyBoxOnPDPEnabled === 'true'
                            ? $(
                                  '.attribute:not(.sibling-attributes-redesign .platform)'
                              )
                            : $(
                                  '.attribute:not(.sibling-attributes .platform)'
                              );
                    if (!$productContainer.length) {
                        $productContainer = $(this).closest('.product-detail');
                    }

                    if (isBuyBoxOnPDPEnabled === 'true') {
                        if (!url || url === '') {
                            const $allColorAttributes = $productContainer.find(
                                '[data-attr="color"] [data-attr-value]'
                            );
                            $allColorAttributes
                                .removeClass('selected')
                                .removeAttr('selected');
                            $swatchElem
                                .addClass('selected')
                                .attr('selected', 'selected');

                            return;
                        }
                    }

                    // update attribute label
                    setAttributeLabel(
                        $(this).parents('.attribute'),
                        $swatchElem.data('attr-display-value')
                    );

                    const trackingData = {
                        action: $.trim(
                            $(this)
                                .parents('.attribute')
                                .find('.attribute-label')
                                .text()
                        ),
                        label: $.trim(
                            $(this)
                                .parents('.attribute')
                                .find('.attribute-value')
                                .text()
                        ),
                        position:
                            $allAttributes.index(
                                $(this).parents('.attribute')
                            ) + 1,
                        productSKU: $productContainer.data('pid')
                    };

                    attributeSelect(
                        url,
                        $productContainer,
                        undefined,
                        trackingData,
                        'color'
                    );
                }
            );
    },

    afterGetStoreAvailability: function () {
        $('body').on('store:afterGetStoreAvailability', function (e, response) {
            updateConditionStoreAvailabilityIcon(response.container);
            updateStorePickupButton(response);
        });
    },

    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.data(
                    'selected-variant-pid',
                    response.data.product.selectedVariantId
                );
                response.container
                    .find('.product-id')
                    .text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                var $productContainer = $('.product-detail');
                var $bundleItem = $('.bundle-product-item', $productContainer);
                if ($bundleItem.length === 0) {
                    response.container.data('pid', response.data.product.id);
                }
                response.container.data(
                    'selected-variant-pid',
                    response.data.product.selectedVariantId
                );
                response.container
                    .find('.product-id')
                    .text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data(
                    'pid',
                    response.data.product.id
                );
                $('.product-detail:not(".bundle-item")').data(
                    'selected-variant-pid',
                    response.data.product.selectedVariantId
                );
            }
        });
    },

    /**
     * initialize variation attribute selection on load or on sibling selection
     */
    clickVariationAttributes: function () {
        handleAttributeSelection();
    }
});

module.exports = exportBase;
